import { Component } from 'react'
import './OutpatientHome.css'
import {
  TextField, IconButton, Tooltip, Box, Typography, Button, ButtonGroup,
  Menu, MenuItem, Stack, Dialog, DialogContent, DialogActions, FormControlLabel,
  Checkbox, Drawer, FormControl, InputLabel, Select,
  Autocomplete,
  TableCell,
  TableRow,
  Modal,
  Table,
  TableHead,
  TableBody,
  Collapse,
  Tabs,
  Tab
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ImagePaths } from '../../../Utility/ImagePaths';
import { AppointmentCard, BillSuccessPoPUp, CommonPatientDetails, NewCommonPatientDetails, ReasonPopup, ConfirmPopup } from '../../../Components/Common Components/CommonComponents';
import { DataGrid, gridNumberComparator } from '@mui/x-data-grid';
import CommonGridHeader, { PovEditPopup } from '../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../Styles/Colors';
import { withTranslation } from 'react-i18next';
import NextAppointments from './NextAppointments';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { clearCachevalue, getCachevalue, localGetItem, setCachevalue } from '../../../Utility/Services/CacheProviderService';
import moment from 'moment/moment';
import { appointment_Status_opt, cmt_Char_limit, appointmentSet, sliceSet, showDilationList, Cancel_appointment_Status_opt } from '../../../Utility/Constants';
import { AmountFormat, CheckAccessFunc, CheckCashCounterAccess, formatToCustomDateTime, calculateWaitingTime } from '../../../Components/CommonFunctions/CommonFunctions';
import PaymentsIcon from '@mui/icons-material/Payments';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportIcon from '@mui/icons-material/Report';
import CreditBillCompletePoP from '../BillingTransaction/CreditBillCompletePoP';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import StopIcon from '@mui/icons-material/Stop';
import ReplayIcon from '@mui/icons-material/Replay';

const DilationList = ["Tropicamide Plus", "Homide", "Cylopentolate"]

class OutpatientHome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      datePicker: new Date(),
      AptTblData: [],
      patientCount: {},
      totalAppointment: {},
      anchorEl: null,
      selectedRow: null,
      selectedOption: "",
      isSelected: false,
      selectedID: "",
      selectedCard: '',
      SelectedPatientDetails: {},
      waitingCmts: false,
      deletedPopup: false,
      cancelAppointment: false,
      page: 0,
      pageSize: 30,
      waitCmtText: '',
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: '',
      timeDiff: null,
      SelectedDoctorID: "",
      DoctorsList: [],
      PatientTagList: [],
      isQmsEnabled: false,
      SelectedPatientTags: [],
      DatePickerOpen: false,
      tokenNum: '',
      barcodeHeader: false,
      creditBillData: [],
      opCreditBill: {},
      receiptID: null,
      pharmacReceipt: null,
      onAddComment: false,
      povText: {},
      ispovPopOpen: false,
      onChangePov: false,
      FilterOpen: false,
      Rescheduled: false,
      Cancelled: false,
      Transferred: false,
      isOPT: false,
      openTransferList: false,
      transDatePickerOpen: false,
      datePickerTrans: new Date(),
      transDataList: [],
      transPage: 0,
      transPageSize: 10,
      loading: false,
      specializationList: [],
      balanceVisible: false,
      balance_details: {},
      balanceAmount: null,
      moveIpPopup: false,
      timers: {},
      refreshCount: 0,
      isTelemedicine: false,
      tagData: [],
      tabClick: false
    }
    this.intervalRefs = {};
  }

  componentDidMount() {
    let DoctorID = JSON.parse(getCachevalue("SelectedDoctorID"))
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"))
    let selectedDate = JSON.parse(getCachevalue('SelectedOPDate'))
    let isOpt = UserData?.is_opt ? UserData?.is_opt : false
    this.setState({ isQmsEnabled: UserData?.is_qms_enabled })
    this.setState({ isOPT: isOpt })
    // uncommented for doctor list api usage
    this.getDoctorsList()
    this.getPatientTagList()
    this.getSpecializationData()
    this.getTransListData()
    if (DoctorID !== this.state.SelectedDoctorID && ((DoctorID != null && DoctorID != undefined))) {
      this.setState({ SelectedDoctorID: DoctorID, datePicker: selectedDate ? selectedDate : new Date() }, () => {
        clearCachevalue('SelectedOPDate')
        this.getPatientDetails()
      })
    } else {
      this.setState({ datePicker: selectedDate ? selectedDate : new Date() }, () => {
        clearCachevalue('SelectedOPDate')
        this.getPatientDetails()
      })
    }
    if (isOpt) {
      this.intervalId = setInterval(() => {
        this.setState({ currentTime: formatToCustomDateTime(new Date()) });
      }, 1000);
    }

  }


  

  componentDidUpdate(prevProps, prevState) {
    let DoctorID = JSON.parse(getCachevalue("SelectedDoctorID"))
    let selectedDate = JSON.parse(getCachevalue('SelectedOPDate'))
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    if (prevProps.history?.location?.state?.NewAppointmentCreated) {
      this.successMsgFunc(prevProps.history?.location?.state?.NewMessage)
      this.props.history.push({ state: { NewAppointmentCreated: false } })
    }
    if (DoctorID !== this.state.SelectedDoctorID && ((DoctorID !== null && DoctorID !== undefined))) {
      this.setState({ SelectedDoctorID: DoctorID, datePicker: selectedDate ? selectedDate : new Date(), tagData: [], tabClick: false, SelectedPatientTags: [],tabClick: false  }, () => {
        // clearCachevalue('SelectedOPDate')
        this.getPatientDetails()
      })
    }
    if (prevProps.history?.location?.state?.RequestBool) {
      this.successMsgFunc(this.props.history?.location?.state?.RequestMessage)
      this.setState({ datePicker: selectedDate ? selectedDate : new Date() }, () => {
        // clearCachevalue('SelectedOPDate')
        this.getPatientDetails()
      })
      this.props.history.push({ state: { RequestBool: false } })
    }
    if (
      (JSON.stringify(Object.keys(this.state.timers)) !== JSON.stringify(Object.keys(prevState.timers)) ||
        this.state.refreshCount !== prevState.refreshCount) && myUser?.new_doctor_notes_template
    ) {
      Object.entries(this.state.timers).forEach(([id, timer]) => {
        const shouldRun = timer.startTime && !timer.endTime && !timer.isPaused;

        if (shouldRun && !this.intervalRefs[id]) {
          this.intervalRefs[id] = setInterval(() => {
            this.setState((prev) => {
              const timers = { ...prev.timers };
              const t = timers[id];

              if (!t || t.isPaused || t.endTime) return null;

              timers[id] = {
                ...t,
                currentTime: new Date(),
              };

              return { timers };
            });
          }, 250);
        }

        if ((!shouldRun || timer.endTime) && this.intervalRefs[id]) {
          clearInterval(this.intervalRefs[id]);
          this.intervalRefs[id] = null;
        }
      });
    }
  }

  componentWillUnmount() {
    Object.values(this.intervalRefs).forEach(clearInterval);
    this.intervalRefs = {};
  }

  errorMsgFunc = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message,
      DisableBtn: false
    })
  }

  successMsgFunc = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message,
      DisableBtn: false
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  ClosePopUp() {
    this.setState({
      creditBillPopUp: false,
      CreditTypeChangePopup: false,
      dataForTypeChage: {},
      receiptID: null,
      pharmacReceipt: null
    })
  }

  ClosesuccessPopUp = () => {
    this.setState({
      receiptID: null,
      pharmacReceipt: null
    })
  }

  getPatientDetails = () => {
    try {
      this.LoaderFunction(true)
      var states = this.state
      var StateDate = new Date(states.datePicker)
      var date = states.datePicker ? DateTime.fromJSDate(StateDate).toFormat('yyyy-MM-dd') : null
      let appointmentFilter = []
      let patientTagFilter = []
      this.state.SelectedPatientTags.forEach(element => patientTagFilter.push(element.patient_tag_name))
      if (states.Rescheduled) {
        appointmentFilter.push("Reschedule")
      }
      if (states.Cancelled) {
        appointmentFilter.push("Cancelled")
      }
      if (states.Transferred) {
        appointmentFilter.push("Transfer")
      }
      appointmentFilter = appointmentFilter.join(",")
      setCachevalue(date, 'OpAppDate')
      setCachevalue(states.selectedCard, 'OPStatus')
      var DoctorId = (JSON.parse(getCachevalue("SelectedDoctorID")) === 0 || JSON.parse(getCachevalue("SelectedDoctorID")) === null || JSON.parse(getCachevalue("SelectedDoctorID")) === undefined) ? "" : JSON.parse(getCachevalue("SelectedDoctorID"));
      if (date === 'Invalid DateTime') {
      } else {
        RestAPIService.getAllTwo(Serviceurls.FO_HOME_OP + `?appointment_date=${date}&appointment_status=${states.selectedCard}&doctor_id=${DoctorId}&appointment_filter=${appointmentFilter}&telemedicine=${states.isTelemedicine}&patient_tag_name=${patientTagFilter}`)
          .then(response => {
            if (response.data.status === "success") {
              const tags = Array.from(
                new Map(
                  response?.data?.data?.map(item => [
                    item?.patient_tag_name,
                    {
                      patient_tag_name: item?.patient_tag_name,
                      patient_tag_color: item?.patient_tag_color,
                    }
                  ])
                ).values()
              )
              const patients = response.data.data;   

              const tagsWithCount = Object.values(
                patients.reduce((acc, item) => {
                  const tag = item.patient_tag_name;

                  if (!tag) return acc;

                  if (!acc[tag]) {
                    acc[tag] = {
                      patient_tag_name: tag,
                      patient_tag_color: item.patient_tag_color,
                      count: 1,
                    };
                  } else {
                    acc[tag].count += 1;
                  }

                  return acc;
                }, {})
              );

              console.log(tagsWithCount);
              const filterTag = tagsWithCount.filter((item) => item?.patient_tag_name !== null)
              if(!this?.state?.tabClick){
                this.setState({
                patientCount: response.data.patient_count ? response.data.patient_count : {},
                })
              }
              this.setState(prevState => ({
                AptTblData: response.data.data ? response.data.data : [],
                tagData: (() => {
                  const listTag = Array.isArray(prevState?.tagData) ? prevState?.tagData : []
                  const tags = filterTag.filter(
                    t => !listTag.some(o => o.patient_tag_name === t.patient_tag_name)
                  );
                  return [...listTag, ...tags]
                })()

                // totalAppointment: response.data.total_appointment ? response.data.total_appointment : {}
              }), () => {
                this.state.AptTblData?.forEach(element => {
                  element.patientDetails = `${element.patient_name || ""} ${element.patient_account_numbers || ""} ${element?.patient_mobile_number || ""} ${element?.doctor_name || ""} ${element?.patient_address_1 || ""} ${element?.patient_address_2 || ""} ${element?.patient_city || ""} ${element?.father_name || ""} ${element?.mother_name || ""} ${element?.patient_tag_name || ""}`
                })
                this.LoaderFunction(false)
                if (!this.state.tabClick) {
                  this.GetStatusCount(date, DoctorId)
                }         
                this.updateTimersFromPatientData(response.data.data || []);
              }
                //Commented for auto calling
                // , () => {
                //   // setTimeout(() => {
                //     //this.getPatientDetails()
                //   }, 40000
              );
              // })
            }
          }).catch(e => {
            this.LoaderFunction(false)
            if (e?.response?.data?.status === "fail") {
              this.errorMsgFunc(e.response.data.message)
            } else {
              this.errorMsgFunc(e.message)
            }
          })
      }
    } catch (e) {
      this.LoaderFunction(false)
      this.errorMsgFunc(e.message)
    }
  }

  updateTimersFromPatientData = (patientData) => {
    const updatedTimers = {};

    patientData.forEach((row) => {
      const id = row.appointment_id;
      const dilation = row.dilation_details ? row.dilation_details?.[0] : {};
      if (!dilation?.start_time) return;

      const startTime = new Date(dilation.start_time);
      const endTime = dilation.end_time ? new Date(dilation.end_time) : null;
      const isPaused = dilation.is_paused ?? false;
      const pauseTime = dilation.pause_time ? new Date(dilation.pause_time) : null;
      const pauseResumeLog = dilation.pause_resume_log || [];

      const totalPausedMs = this.calculateTotalPausedTime(
        pauseResumeLog,
        endTime,
        isPaused,
        pauseTime
      );

      const effectiveStartTime = new Date(startTime.getTime() + totalPausedMs);
      const currentTime = endTime ? endTime : isPaused && pauseTime ? pauseTime : new Date();

      updatedTimers[id] = {
        startTime: effectiveStartTime,
        originalStartTime: startTime,
        endTime,
        currentTime,
        isPaused,
        pauseStartTime: isPaused ? pauseTime : null,
        totalPausedMs,
      };
    });

    if (Object.keys(updatedTimers).length > 0) {
      this.setState((prevState) => ({
        timers: { ...prevState.timers, ...updatedTimers },
      }));
    }
  };

  calculateTotalPausedTime = (log = [], endTime = null, isPaused = false, pauseTime = null) => {
    let totalPausedMs = 0;

    for (let i = 0; i < log.length; i++) {
      const pauseEntry = log[i];
      const resumeEntry = log[i + 1];

      if (pauseEntry.pause && resumeEntry?.resume) {
        const pause = new Date(pauseEntry.pause).getTime();
        const resume = new Date(resumeEntry.resume).getTime();
        totalPausedMs += resume - pause;
        i++;
      } else if (pauseEntry.pause && !resumeEntry) {
        const pause = new Date(pauseEntry.pause).getTime();
        let virtualResume;

        if (endTime) {
          virtualResume = new Date(endTime).getTime();
        } else if (isPaused && pauseTime) {
          virtualResume = new Date(pauseTime).getTime();
        } else {
          virtualResume = new Date().getTime();
        }

        totalPausedMs += virtualResume - pause;
      }
    }

    return totalPausedMs;
  };

  formatTimeDiff = (originalStart, current, totalPaused = 0) => {
    const s = new Date(originalStart).getTime();
    const e = new Date(current).getTime();
    const diff = e - s - totalPaused;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return (
      <Typography fontSize={'0.8vw'} fontWeight={600} color={diff > 1200000 ? 'red' : 'black'}>
        {diff > 0 ? `${hours} Hr : ${minutes} Min : ${seconds} Sec` : '0 Hr : 0 Min : 0 Sec'}
      </Typography>
    );
  };

  GetStatusCount = (date, DoctorId) => {
    try {
      let patientTagFilter = []
      this.state.SelectedPatientTags.forEach(element => patientTagFilter.push(element.patient_tag_name))
      RestAPIService.getAll(Serviceurls.FO_PATIENT_COUNT_DETAILS_GET + `?appointment_date=${date}&doctor_id=${DoctorId}&patient_tag_name=${patientTagFilter}`).
        then((response) => {
          if (response.data.status === "success") {
             if (!this.state.tabClick) {
             this.setState({
              totalAppointment: response.data.data ? response.data.data : {}
            })
            }  
            
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMsgFunc(error.message)
          }
        })
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMsgFunc(error.message)
    }
  }
  
  getPatientCompletedBillData = (data) => {
    try {
      this.LoaderFunction(true)
      RestAPIService.getAll(Serviceurls.FO_PATIENT_BILL_DETAILS_GET + "?patient_id=" + data?.patient_id).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              creditBillData: response.data.data
            }, () => {
              let selectedAppointment = response.data.data.filter((item) => item?.appointment_date === data?.appointment_date)
              this.setState({ creditBillPopUp: true, opCreditBill: selectedAppointment[0], PatientDetails: data })
              this.LoaderFunction(false)
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.LoaderFunction(false)
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.LoaderFunction(false)
            this.errorMsgFunc(error.message)
          }
        })
    } catch (error) {
      this.LoaderFunction(false)
      this.errorMsgFunc(error.message)
    }
  }

  creditBillPost = (message = "", receiptNo = null, phrReceipt = null, error = false, OpId = []) => {
    this.setState({
      creditBillPopUp: false,
      receiptID: receiptNo,
      pharmacReceipt: phrReceipt,
      OpPopupId: OpId
    }
      , () => {
        if (error) {
          this.errorMsgFunc(message)
        } else {
          this.successMsgFunc(message)
          this.getPatientDetails()
        }
      })
  }

  postPatientStatus = (status, id, comments, time, waitTime, rowData) => {
    try {
      var states = this.state
      var data = {
        "appointment_id": id,
        "appointment_status": status,
        ...(status === "Arrived" && {
          appointment_time: DateTime.fromJSDate(new Date()).toLocaleString(DateTime.TIME_24_WITH_SECONDS)
        })
      }
      if (rowData && !waitTime) {
        const waiting_time = calculateWaitingTime(rowData);
        data["waiting_timer"] = waiting_time
      } else {
        data["waiting_timer"] = waitTime ? waitTime : null
      }

      if (states.waitingCmts) {
        data['waiting_comment'] = comments
      }
      if (states.cancelAppointment) {
        data['cancel_reason'] = comments.replace(/\s+/g, ' ').trim()
      }
      RestAPIService.create(data, Serviceurls.FO_HOME_OP_STATUS)
        .then(response => {
          if (response.data.status == "success") {
            this.getPatientDetails()
            this.setState({
              waitCmtText: '',
              DisableBtn: false
            })
          }
        }).catch(e => {
          this.setState({ DisableBtn: false })
          if (e?.response?.data?.status === "fail") {
            this.errorMsgFunc(e.response.data.message)
          } else {
            this.errorMsgFunc(e.message)
          }
        })
    } catch (e) {
      this.setState({ DisableBtn: false })
      this.errorMsgFunc(e.message)
    }
  }

  getDoctorsList() {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              DoctorsList: response.data.data.filter((item) => (item.specialization_active === true))
            })
          }
          else {
            this.errorMsgFunc(response.data.message)
          }
        }).catch((e) => {
          this.errorMsgFunc(e.message)
        })
    }
    catch (e) {
      this.errorMsgFunc(e.message)
    }
  }

  getPatientTagList() {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPPATIENTTAG).
        then((response) => {
          if (response.data.status === "success") {
            this.setState({
              PatientTagList: response.data.data
            })
          }
          else {
            this.errorMsgFunc(response.data.message)
          }
        }).catch((e) => {
          this.errorMsgFunc(e.message)
        })
    }
    catch (e) {
      this.errorMsgFunc(e.message)
    }
  }

  getPatientPrescriptionPrint = () => {
    try {
      let APIUrl = ""
      if (this.state.SelectedPatientDetails?.speciality === Serviceurls.ROLE_OPT) {
        // Serviceurls.OP_DOCTOR_PRECSCRIPTION_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id
        APIUrl = Serviceurls.OPT_PRESCRIPTION_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&language=english"
      }
      else {
        APIUrl = Serviceurls.PRINT_PRESCRIPTION + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&export_type=pdf"
      }

      RestAPIService.getAllTwo(APIUrl).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "" })
    }
  }

  getPatientDoctorNotesPrint = () => {
    try {
      var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
      let APIUrl = ""
      if (myUser?.new_doctor_notes_template) {
        APIUrl = Serviceurls.NEW_DOC_NOTES_VISIT_REPORT_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id + "&doctor_notes=" + "all"
      }
      else if (this.state.SelectedPatientDetails?.speciality === Serviceurls.ROLE_OPT) {
        APIUrl = Serviceurls.OPT_PATIENT_DOCTOR_NOTES_PRINT + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id
      } else {
        const UserData = JSON.parse(localGetItem("loggedInUserInfo"));
        const baseUrl = UserData?.new_doctor_notes_template_others ?
          Serviceurls.SARAS_DOC_VISIT_REPORT_GET :
          Serviceurls.DOCTOR_NOTES_PRINT;
        APIUrl = baseUrl + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&doctor_notes=all" + "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id
      }
      RestAPIService.getAllPrint(APIUrl)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "" })
    }
  }

  getCustomizedCardPrint = () => {
    try {
      RestAPIService.getAll(Serviceurls.OP_CUSTOMIZED_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientOpCardPrint = (barcodeHeader) => {
    try {
      let Url = ""
      if (barcodeHeader) {
        Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id + "&header=false"
      } else {
        Url = Serviceurls.OP_CARD_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id
      }
      RestAPIService.getAll(Url).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientOpBillDetailPrint = () => {
    try {
      RestAPIService.getAll(((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_OP_DETAILED_BILL_PRINT : Serviceurls.OP_DETAILED_BILL_PRINT) + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientOpSummaryBillPrint = () => {
    try {
      RestAPIService.getAll(((localGetItem('isNewBilling') === "true") ? Serviceurls.NEW_OP_SUMMARY_BILL_PRINT : Serviceurls.OP_SUMMARY_BILL_PRINT) + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({
            selectedOption: ""
          })
        }).catch((error) => {
          this.setState({ selectedOption: "" })
          this.errorMsgFunc(error.response?.data?.message);
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getPatientPresTemplate = () => {
    try {
      let token = this.state.tokenNum ? this.state.tokenNum : null
      RestAPIService.getAllPrint(Serviceurls.OP_PRES_TEMPLATE + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id +
        "&doctor_id=" + this.state.SelectedPatientDetails?.doctor_id +
        "&token_number=" + token + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          this.errorMsgFunc(error.response?.data?.message);
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.setState({ selectedOption: "" })
    }
  }

  getCommonBarCodePrint = () => {
    try {
      RestAPIService.getAll(Serviceurls.COMMON_BARCODE_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id + "&appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  OPPatientDataSheetPrint = () => {
    try {
      RestAPIService.getAll(Serviceurls.OP_PATIENT_DATA_PRINT + "?patient_id=" + this.state.SelectedPatientDetails?.patient_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getGlassPrescriptionPrint = () => {
    try {
      let loginInfo = JSON.parse(localGetItem('loggedInUserInfo'))
      const isUmaNote = loginInfo?.new_doctor_notes_template;
      let params = ''
      if (isUmaNote) {
        params = Serviceurls.NEW_DOC_NOTES_GLASS_PRESCRIPTION + `?patient_id=${this.state.SelectedPatientDetails?.patient_id}&clinic_id=${loginInfo?.clinic_id}&appointment_id=${this.state.SelectedPatientDetails?.appointment_id}&doctor_id=${this.state.SelectedPatientDetails?.doctor_id}&export_type=pdf`
      } else {
        params = Serviceurls.DOC_PRINT_ORDER_REPORT + `?patient_id=${this.state.SelectedPatientDetails?.patient_id}&appointment_id=${this.state.SelectedPatientDetails?.appointment_id}&from_date=&to_date=&test=${'Glass Prescription'}&export_type=pdf`
      }
      RestAPIService.getAllPrint(params).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  getMedicalRecordPrint = () => {
    try {
      RestAPIService.GetWithoutReplica(Serviceurls.Medical_Record_PRINT_CONFIG_PREVIEW + "?appointment_id=" + this.state.SelectedPatientDetails?.appointment_id).
        then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.setState({ selectedOption: "" })
        }).catch((error) => {
          if (error.response?.data?.message) {
            this.errorMsgFunc(error.response?.data?.message);
          } else {
            this.errorMsgFunc(error.message);
          }
          this.setState({ selectedOption: "" })
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }
  // Print Appointment list for 4.0 start
  printAppList() {
    try {
      var date = getCachevalue('OpAppDate')
      var opstatus = getCachevalue('OPStatus')
      var DoctorId = (JSON.parse(getCachevalue("SelectedDoctorID")) === 0 || JSON.parse(getCachevalue("SelectedDoctorID")) === null || JSON.parse(getCachevalue("SelectedDoctorID")) === undefined) ? "" : JSON.parse(getCachevalue("SelectedDoctorID"));
      this.setState({ disableBtn: true })
      let patientTagFilter = []
      this.state.SelectedPatientTags.forEach(element => patientTagFilter.push(element.patient_tag_name))
      RestAPIService.PrintPDF(Serviceurls.FO_APPINMENT_PRIENT + "?appointment_date=" + date + "&doctor_id=" + DoctorId + "&appointment_status=" + opstatus + '&patient_tag_name=' + patientTagFilter).
        then((response) => {
          if (response) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            //Open the URL on new Window
            window.open(fileURL);
            this.setState({ disableBtn: false })
          }
        }).catch((error) => {
          this.setState({ disableBtn: false })
          console.log(error.message)
        })
    } catch (e) {
      this.setState({ disableBtn: false })
      console.log(e.message)
    }
  }
 
  getAssetListExcel = () => {
    var states = this.state
      var StateDate = new Date(states.datePicker)
      var date = states.datePicker ? DateTime.fromJSDate(StateDate).toFormat('yyyy-MM-dd') : null
      let appointmentFilter = []
      let patientTagFilter = []
      this.state.SelectedPatientTags.forEach(element => patientTagFilter.push(element.patient_tag_name))
      if (states.Rescheduled) {
        appointmentFilter.push("Reschedule")
      }
      if (states.Cancelled) {
        appointmentFilter.push("Cancelled")
      }
      if (states.Transferred) {
        appointmentFilter.push("Transfer")
      }
      appointmentFilter = appointmentFilter.join(",")
      setCachevalue(date, 'OpAppDate')
      setCachevalue(states.selectedCard, 'OPStatus')
      var DoctorId = (JSON.parse(getCachevalue("SelectedDoctorID")) === 0 || JSON.parse(getCachevalue("SelectedDoctorID")) === null || JSON.parse(getCachevalue("SelectedDoctorID")) === undefined) ? "" : JSON.parse(getCachevalue("SelectedDoctorID"));
    try {
      var date = getCachevalue('OpAppDate')
      var opstatus = getCachevalue('OPStatus')
      this.setState({ disableBtn: true })
      let patientTagFilter = []
      this.state.SelectedPatientTags.forEach(element => patientTagFilter.push(element.patient_tag_name))     
      RestAPIService.excelGet(
        Serviceurls.FO_APPINMENT_LIST_EXPORT +
        "?appointment_date=" + date + "&appointment_status=" + opstatus + "&doctor_id=" + DoctorId + "&appointment_filter=" + appointmentFilter + "&telemedicine=" + states.isTelemedicine + '&patient_tag_name=' + patientTagFilter +
        "&export_type=excel",
        { responseType: "arraybuffer" }
      )
        .then((response) => {
          if (response.data) {
            var pom = document.createElement('a');
            var csvContent = response.data;

            let filename = response.headers["content-disposition"]
              ?.split("filename=")[1]
              ?.replace(/"/g, "");

            var blob = new Blob([csvContent], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            var url = URL.createObjectURL(blob);
            pom.href = url;
            pom.setAttribute('download', filename ? filename : 'registry.xlsx');
            pom.click();

            this.setState({ disableBtn: false });  // re-enable button
          }
        })
        .catch((error) => {
          this.setState({ disableBtn: false })
          console.log(error.message)
        })
    } catch (error) {
      this.setState({ disableBtn: false })
      console.log(error.message)
    }
  };


  renderOPHeader = () => {
    const { t } = this.props
    let userData = JSON.parse(localGetItem("loggedInUserInfo"))
    return (
      <div className='eMed_OP_AptHead'>
        <p>{t('OPAppointments')}</p>
        <div className='eMed_Header_OP_home_div'>
          {
            this.state.datePicker < new Date() && (DateTime.fromJSDate(new Date(this.state.datePicker)).toFormat('yyyy-MM-dd') !== DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')) && localGetItem("noShowStatus") === "true" ?
              <Button
                className={this.state.selectedCard === 'No Show' ? "eMed_Header_OP_Noshow_btn_on" : 'eMed_Header_OP_Noshow_btn'} size='small'
                onClick={() => { this.setState({ selectedCard: 'No Show',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }}>
                {`No Show ( ${this.state.totalAppointment?.no_show ? this.state.totalAppointment?.no_show : 0} )`}
              </Button> : null
          }
          {userData?.has_telemedicine ? <Button variant='contained'
            sx={{ textTransform: 'capitalize', mr: '0.5dvw', backgroundColor: this.state.isTelemedicine ? '#024947ff' : '#04B7B1' }}
            size='small'
            onClick={() => { this.setState({ isTelemedicine: !this.state.isTelemedicine }, () => { this.getPatientDetails() }) }}
          >
            {`Telemedicine (${this.state.totalAppointment?.total_tele_appointment || 0})`}
          </Button> : null}
          {userData?.is_qms_enabled ?
            <Button
              variant='contained'
              sx={{ textTransform: 'capitalize', mr: '0.5dvw' }}
              size='small'
              onClick={() => { this.setState({ openTransferList: true }) }}>
              {`transferred List (${this.state.transDataList?.length ? this.state.transDataList?.length : 0})`}
            </Button> : null
          }

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              open={this.state.DatePickerOpen}
              onOpen={() => { this.setState({ DatePickerOpen: true }) }}
              onClose={() => { this.setState({ DatePickerOpen: false }) }}
              value={this.state.datePicker}
              name={"datePicker"}
              inputFormat='DD-MM-YYYY'
              views={["year", "month", "day"]}
              onChange={
                (newDate) => {
                  this.setState({
                    datePicker: newDate,
                    selectedCard: '',
                    tagData: [],
                    tabClick: false,
                    SelectedPatientTags: [],
                    tagData:''
                  }, () => {
                    setCachevalue(JSON.stringify(this.state.datePicker), "SelectedOPDate")
                    this.getPatientDetails()
                  });
                }}
              renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} style={{ width: '10vw' }} size='small' {...params} onClick={() => { this.setState({ DatePickerOpen: true }) }} />}
            />
          </LocalizationProvider>
          {userData?.is_qms_enabled || localGetItem('show_patient_tag_filter') === "true" ?
            <Tooltip title="Filter" placement='top' arrow>
              <Button className='eMed_usrconf_btn' emed_tid='opHome_filter_btn' onClick={() => { this.setState({ FilterOpen: true }) }}>
                <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
              </Button>
            </Tooltip>
            : null}
          <Button className='eMed_usrconf_btn' onClick={() => { this.getAssetListExcel() }} disabled={this.state.disableBtn}>
            <img src={ImagePaths.ExportIcon.default} alt="excel" className='eMed_action_img' />
          </Button>
          <button emed_tid="appointment_list_print_btn" className='fo_print_icon' onClick={() => {
            this.printAppList()
          }} disabled={this.state.disableBtn}>
            <img style={{ height: '1.2vw', width: '1.2vw' }} src={ImagePaths.Print.default} alt='Print' />
          </button>
        </div>
      </div>
    )
  }

  renderPatientType = () => {
    const { t } = this.props
    let { history } = this.props;
    var states = this.state
    // Opt Doc filter
    let is_opt = false
    let is_selectopt = false
    var is_optdoc = states.DoctorsList.find((item) => {
      if (item.specialization_name === Serviceurls.ROLE_OPT || item.specialization_name === Serviceurls.ROLE_OPTOMETRY) {
        is_opt = true
      } else {
        is_opt = false
      }
      return is_opt
    }
    )
    // select Opt Doc filter
    var is_optselect = getCachevalue('SelectedDoctorID')
    var is_optDocselect = states.DoctorsList.filter((item) => (item.doctor_id === +is_optselect))
    var is_selectoptdoc = is_optDocselect.find((item) => {
      if (item.specialization_name === Serviceurls.ROLE_OPT || item.specialization_name === Serviceurls.ROLE_OPTOMETRY) {
        is_selectopt = true
      } else {
        is_selectopt = false
        is_optdoc = false
      }
      return is_selectopt, is_optdoc
    }
    )
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var UserData = myUser
    let appointmentStatus = JSON.parse(localGetItem('appointment_status')) ? JSON.parse(localGetItem('appointment_status')) :
      JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status :
        appointment_Status_opt : appointment_Status_opt
    return (
      <div className='eMed_OP_AddPatient'>
        <div className='eMed_OP_PatientType_CreateBtn' >
          {UserData?.module_name !== 'nurse' ?
            <div>
              <Tooltip title={t('CreatePatient')} placement='top' arrow>
                <IconButton onClick={() => { history.push({ pathname: (localGetItem('isNewBilling') === "true") ? "/OPHome/Billing/NewQuickBilling" : "/OPHome/Billing/QuickBilling" }) }}>
                  <img className='eMed_OP_AddPatient_Icon' src={ImagePaths.AddNewPatient.default} alt={"Add Patient"} />
                </IconButton>
              </Tooltip>
            </div> : null}
          <div className='eMed_OP_PatientTypeCont'>
            <p className='eMed_OP_TypeNew'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.NewPatient.default} alt={'New Patient'} /> {t('NewPatients') + ' (' + (states.patientCount.new_patient ? states.patientCount.new_patient : '0') + ')'}</p>
            <p className='eMed_OP_TypeEstablished'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.EstablishedPatient.default} alt={'Review Patient'} /> {t('ReviewPatients') + ' (' + (states.patientCount.review_patient ? states.patientCount.review_patient : '0') + ')'}</p>
            <p className='eMed_OP_TypeEstablished'><img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.ReviewPatient.default} alt={'Old Patient'} /> {t('Old Patients') + ' (' + (states.patientCount.old_patient ? states.patientCount.old_patient : '0') + ')'}</p>
          </div>
        </div>
        <div>
          <div className='eMed_OP_Apt_Cards' style={{ width: "80dvw", placeContent: "end" }}>
            {/* <div style={{ position: 'relative', width: '100%' }}> */}
            {/* <button className="scroll-button left" onClick={() => this.scrollCards('left')}>&lt;</button> */}
            <AppointmentCard onClick={() => { this.setState({ selectedCard: '',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.total} label={t("All")} color={"#616161"} isSelectedCard={states.selectedCard === "" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Booked' ,tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.booked} label={t("Booked")} color={"#616161"} isSelectedCard={states.selectedCard === "Booked" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Ip Appointment',tagData:[],tabClick: false,SelectedPatientTags: []  }, () => { this.getPatientDetails() }) }} icon={ImagePaths.BookedPatientFill.default} count={states.totalAppointment.ip_appointment} label={t("IP Appointment")} color={"#5fbe39"} isSelectedCard={states.selectedCard === "Ip Appointment" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Arrived' ,tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusArrivedFill.default} count={states.totalAppointment.arrived} label={t("Arrived")} color={"#0461B7"} isSelectedCard={states.selectedCard === "Arrived" ? true : false} />
            <Collapse in={this.state.selectedCard === "Arrived" || this.state.selectedCard === "With Nurse" || this.state.selectedCard === "With OPTOS" || this.state.selectedCard === "Optometry" || this.state.selectedCard === "Optometry Completed"} orientation="horizontal" timeout={500} style={{ display: "flex" }}>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                {this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
                  <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Nurse',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusNurseFill.default} count={states.totalAppointment.with_nurse} label={t("WithNurse")} color={"#AF2591"} isSelectedCard={states.selectedCard === "With Nurse" ? true : false} /> :
                  appointmentStatus[1]?.is_checked ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Nurse',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusNurseFill.default} count={states.totalAppointment.with_nurse} label={t("WithNurse")} color={"#AF2591"} isSelectedCard={states.selectedCard === "With Nurse" ? true : false} /> : null}
                {this.state.totalAppointment?.with_optos > 0 && !appointmentStatus[2]?.is_checked ?
                  (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With OPTOS',tagData:[],tabClick: false ,SelectedPatientTags: []}, () => { this.getPatientDetails() }) }} icon={ImagePaths.OPTOSfill.default} count={states.totalAppointment.with_optos} label={t("With OPTOS")} color={"#fa0004"} isSelectedCard={states.selectedCard === "With OPTOS" ? true : false} /> : null) :
                  appointmentStatus[2]?.is_checked ?
                    (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With OPTOS',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.OPTOSfill.default} count={states.totalAppointment.with_optos} label={t("With OPTOS")} color={"#fa0004"} isSelectedCard={states.selectedCard === "With OPTOS" ? true : false} /> : null) : null}
                {this.state.totalAppointment?.optometry > 0 && !appointmentStatus[3]?.is_checked ?
                  (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Optometry',tagData:[],tabClick: false ,SelectedPatientTags: []}, () => { this.getPatientDetails() }) }} icon={ImagePaths.OptometryFill.default} count={states.totalAppointment.optometry} label={t("With Optometry")} color={"#ffff33"} isSelectedCard={states.selectedCard === "Optometry" ? true : false} /> : null) :
                  appointmentStatus[3]?.is_checked ?
                    (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Optometry',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.OptometryFill.default} count={states.totalAppointment.optometry} label={t("With Optometry")} color={"#ffff33"} isSelectedCard={states.selectedCard === "Optometry" ? true : false} /> : null) : null}
                {((this.state.totalAppointment?.optometry_completed > 0 && !appointmentStatus[4]?.is_checked) || appointmentStatus[4]?.is_checked) && (is_optdoc || is_selectoptdoc) ?
                  <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Optometry Completed',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.withOptCompletedOn.default} count={states.totalAppointment?.optometry_completed || 0} label={t("Opt Completed")} color={"orange"} isSelectedCard={states.selectedCard === "Optometry Completed"} />
                  : null}
              </div>
            </Collapse>
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Doctor',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.StatusDoctorFill.default} count={states.totalAppointment.with_doctor} label={t("WithDoctor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Doctor" ? true : false} />
            <Collapse in={this.state.selectedCard === "With Doctor" || this.state.selectedCard === "In Opticals" || this.state.selectedCard === "Opticals Completed" || this.state.selectedCard === "With Counsellor" || this.state.selectedCard === "Scan/Surgery"} orientation="horizontal" timeout={500} style={{ display: "flex" }}>
              <div style={{ display: "flex", gap: "0.5rem" }}>
                {this.state.totalAppointment?.in_opticals > 0 && !appointmentStatus[6]?.is_checked ?
                  (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'In Opticals' ,tagData:[],tabClick: false,SelectedPatientTags: []}, () => { this.getPatientDetails() }) }} icon={ImagePaths.InOpticals.default} count={states.totalAppointment.in_opticals} label={t("In Opticals")} color={"#00d773ff"} isSelectedCard={states.selectedCard === "In Opticals" ? true : false} /> : null) :
                  appointmentStatus[6]?.is_checked ?
                    (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'In Opticals',tagData:[],tabClick: false ,SelectedPatientTags: []}, () => { this.getPatientDetails() }) }} icon={ImagePaths.InOpticals.default} count={states.totalAppointment.in_opticals} label={t("In Opticals")} color={"#00d773ff"} isSelectedCard={states.selectedCard === "In Opticals" ? true : false} /> : null) : null
                }
                {this.state.totalAppointment?.opticals_completed > 0 && !appointmentStatus[7]?.is_checked ?
                  (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Opticals Completed',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.OpticalsCompleted.default} count={states.totalAppointment.opticals_completed} label={t("Opticals Completed")} color={"#2ee9e9ff"} isSelectedCard={states.selectedCard === "Opticals Completed" ? true : false} /> : null) :
                  appointmentStatus[7]?.is_checked ?
                    (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Opticals Completed',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.OpticalsCompleted.default} count={states.totalAppointment.opticals_completed} label={t("Opticals Completed")} color={"#2ee9e9ff"} isSelectedCard={states.selectedCard === "Opticals Completed" ? true : false} /> : null) : null
                }
                {this.state.totalAppointment?.with_counsellor > 0 && !appointmentStatus[8]?.is_checked ?
                  <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Counsellor',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.withCounsellorOn.default} count={states.totalAppointment.with_counsellor ? states.totalAppointment.with_counsellor : 0} label={t("With Counsellor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Counsellor" ? true : false} /> :
                  appointmentStatus[8]?.is_checked ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'With Counsellor',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.withCounsellorOn.default} count={states.totalAppointment.with_counsellor ? states.totalAppointment.with_counsellor : 0} label={t("With Counsellor")} color={"#29B6F6  "} isSelectedCard={states.selectedCard === "With Counsellor" ? true : false} /> : null}
                {this.state.totalAppointment?.scan_surgery > 0 && !appointmentStatus[9]?.is_checked ?
                  (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Scan/Surgery',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.ScanSurgeryFill.default} count={states.totalAppointment.scan_surgery} label={t("Scan/Surgery")} color={"#ff9900"} isSelectedCard={states.selectedCard === "Scan/Surgery" ? true : false} /> : null) :
                  appointmentStatus[9]?.is_checked ?
                    (is_optdoc || is_selectoptdoc ? <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Scan/Surgery',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.ScanSurgeryFill.default} count={states.totalAppointment.scan_surgery} label={t("Scan/Surgery")} color={"#ff9900"} isSelectedCard={states.selectedCard === "Scan/Surgery" ? true : false} /> : null) : null
                }
              </div>
            </Collapse>
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Completed',tagData:[],tabClick: false,SelectedPatientTags: [] }, () => { this.getPatientDetails() }) }} icon={ImagePaths.CompletedPatientFill.default} count={states.totalAppointment.completed} label={t("Completed")} color={"#1E972A"} isSelectedCard={states.selectedCard === "Completed" ? true : false} />
            <AppointmentCard onClick={() => { this.setState({ selectedCard: 'Cancelled' ,tagData:[],tabClick: false,SelectedPatientTags: []}, () => { this.getPatientDetails() }) }} icon={ImagePaths.CancelPatients.default} count={states.totalAppointment.cancelled} label={t("Cancelled")} color={"#B8170D"} isSelectedCard={states.selectedCard === "Cancelled" ? true : false} />
            {/* <button className="scroll-button right" onClick={() => this.scrollCards('right')}>&gt;</button> */}
          </div>
          {/* </div> */}
        </div>
      </div>
    )
  }

  scrollCards = (direction) => {
    const scrollAmount = 300;
    if (this.cardsContainer) {
      this.cardsContainer.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  AppointmentTypeIcon(type) {
    const { t } = this.props
    switch (type) {
      case "Telephonic Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("TelephonicAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Telephonic.default}></img></Tooltip></div>
      case "Mobile Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("MobileAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Phone.default}></img></Tooltip></div>
      case "Online Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Online Appointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Web.default}></img></Tooltip></div>
      case "Web Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("WebAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Web.default}></img></Tooltip></div>
      case "Walk in Appointment": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("WalkAppointment")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Walkin.default}></img></Tooltip></div>
      // case "transfer": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Transfered")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Transfer.default}></img></Tooltip><span id='eMed_OP_AptTbl_AptText' style={{ fontWeight: '600' }}>{" (Transfered)"}</span></div>
      case "transfer": return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={t("Transferred")} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.Transfer.default}></img></Tooltip></div>
      default: return <div className='eMed_OP_AptType_Icon'><Tooltip placement='top' title={type === null ? t("Others") : type} arrow><img className='eMed_OP_Patient_Iconcircle_Appointment' src={ImagePaths.DefaultAppointType.default}></img></Tooltip></div>
    }
  }

  moduleBalance(balDetail, balAmount) {
    if (balDetail && Object.keys(balDetail).length > 0) {
      this.setState({ balanceVisible: true, balance_details: balDetail, balanceAmount: balAmount })
    }
  }

  PaymentStatus(BillAmount, ReceivedAmount, BalanceDetails = {}) {
    let balAmount = BillAmount - ReceivedAmount;
    return (
      <Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <PaymentsIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: '#616161' }} />
          <Typography fontSize={"0.8vw"}>{`Bill : ${AmountFormat(BillAmount)} `}</Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <CheckCircleIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: 'green' }} />
          <Typography color={"green"} fontSize={"0.8vw"}>{`Paid : ${AmountFormat(ReceivedAmount)} `}</Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={(e) => { e.stopPropagation(); this.moduleBalance(BalanceDetails, balAmount) }}>
          <ReportIcon sx={{ fontSize: "0.9vw", marginRight: '0.4vw', color: "#B8170D" }} />
          <Typography color={"#B8170D"} fontSize={"0.8vw"}>{`Balance : ${AmountFormat(BillAmount - ReceivedAmount)} `}</Typography>
        </Box>
      </Box>
    )
  }

  calculateTimeDifference = (StartTime, StopTime) => {
    const start = new Date(StartTime);
    const end = new Date(StopTime);
    const difference = end.getTime() - start.getTime();
    const hours = Math.floor(difference / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    return <Typography fontSize={'0.8vw'} fontWeight={600} color={difference > 1200000 ? "red" : "black"}>{difference > 0 ? `${hours} Hr : ${minutes} Min : ${seconds} Sec` : "0 Hr : 0 Min: 0 Sec"}</Typography>;
  };

  UpdateDilationTimeUMA = (id, StartTime = false, EndTime = false, isPaused = false, reset = false, resume = false) => {
    return new Promise((resolve) => {
      try {
        this.setState({ loading: true });

        const data = {
          dilation: 'Homide',
          appointment_id: id,
          set_start_time: StartTime,
          set_end_time: EndTime,
          pause: isPaused,
          reset: reset,
          resume: resume,
        };

        RestAPIService.create(data, Serviceurls.DOC_DILATION_TIMER_UPDATE)
          .then((response) => {
            this.setState({ loading: false });
            if (response.data.status === "success") {
              this.getPatientDetails();
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch((e) => {
            this.setState({ loading: false });
            this.errorMsgFunc(e?.response?.data?.message || e.message);
            resolve(false);
          });
      } catch (e) {
        this.setState({ loading: false });
        this.errorMsgFunc(e.message);
        resolve(false);
      }
    });
  };

  UpdateDilationTime = (id, StartTime = false, EndTime = false, index, selectDilation) => {
    try {
      let DilationObj = this.state.AptTblData.find((list) => (list?.appointment_id === id)) ? this.state.AptTblData.find((list) => (list?.appointment_id === id))?.dilation_details : null
      let DilationValue = DilationObj ? DilationObj[index] ? DilationObj[index]?.dilation : null : null
      if (DilationValue) {
        var data = {
          "appointment_id": id,
          "dilation": DilationValue,
          "set_start_time": StartTime,
          "set_end_time": EndTime
        }
        if (selectDilation) {
          data = {
            "appointment_id": id,
            "dilation": DilationValue,
            "dilation_type_change": true,
            "set_start_time": StartTime,
            "set_end_time": EndTime
          }
        }
        RestAPIService.create(data, Serviceurls.DOC_DILATION_TIMER_UPDATE)
          .then(response => {
            if (response.data.status == "success") {
              this.getPatientDetails()
            }
          }).catch(e => {
            if (e?.response?.data?.status === "fail") {
              this.errorMsgFunc(e.response.data.message)
            } else {
              this.errorMsgFunc(e.message)
            }
          })
      } else {
        this.errorMsgFunc("Select the Dilation Type")
      }
    } catch (e) {
      this.errorMsgFunc(e.message)
    }
  }
  renderDilationSelect = (id, index) => {
    let DilationObj = this.state.AptTblData.find((list) => (list?.appointment_id === id)) ? this.state.AptTblData.find((list) => (list?.appointment_id === id))?.dilation_details : null
    let DilationValue = DilationObj ? DilationObj[index] ? DilationObj[index]?.dilation : null : null
    let DilationValueDisable = DilationObj ? DilationObj[index] ? (DilationObj[index]?.start_time || DilationObj[index]?.end_time) : false : false
    return (
      <FormControl variant="standard" size='small' sx={{ width: '15vw', padding: 0, marginLeft: '1vw' }}>
        <InputLabel>{'Dilation'}</InputLabel>
        <Select
          label={'Dilation'}
          value={DilationValue}
          disabled={(DilationValueDisable)}
          onChange={(e) => {
            let data = this.state.AptTblData
            if (data[this.state.AptTblData.findIndex((list) => (list?.appointment_id === id))].dilation_details) {
              data[this.state.AptTblData.findIndex((list) => (list?.appointment_id === id))].dilation_details[index].dilation = e.target.value
            } else {
              data[this.state.AptTblData.findIndex((list) => (list?.appointment_id === id))].dilation_details = [
                {
                  "dilation": e.target.value,
                  "end_time": "",
                  "start_time": ""
                }
              ]
            }
            this.setState({ AptTblData: data }, () => {
              this.UpdateDilationTime(id, false, false, index, true)
            })
          }}
          inputProps={{ style: { padding: 0, fontSize: '0.9vw' } }}
        >
          {DilationList?.map((item, index) => (
            <MenuItem key={index} value={item}>{item}</MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }

  StatusBtns(data, id) {
    const { t } = this.props
    let FirstDilationDetails = data?.dilation_details ? data?.dilation_details[0] : {}
    let SecondDilationDetails = data?.dilation_details ? data?.dilation_details[1] : null
    let appointmentStatus = JSON.parse(localGetItem('appointment_status')) ? JSON.parse(localGetItem('appointment_status')) :
      JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.appointment_status :
        appointment_Status_opt

    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))

    const dilation = data.dilation_details?.[0] || {};

    const timers = this.state.timers || {};

    let timer = timers[id] || {
      originalStartTime: dilation.start_time ? new Date(dilation.start_time) : null,
      endTime: dilation.end_time ? new Date(dilation.end_time) : null,
      isPaused: dilation.is_paused ?? false,
      pauseStartTime: dilation.pause_time ? new Date(dilation.pause_time) : null,
      totalPausedMs: 0,
      currentTime: new Date(),
      startTime: dilation.start_time ? new Date(dilation.start_time) : null,
    };

    if (timer.originalStartTime) {
      const pauseResumeLog = dilation.pause_resume_log || [];
      const totalPausedMs = this.calculateTotalPausedTime(
        pauseResumeLog,
        timer.endTime,
        timer.isPaused,
        timer.pauseStartTime
      );

      const effectiveStartTime = new Date(timer.originalStartTime.getTime() + totalPausedMs);

      timer.totalPausedMs = totalPausedMs;
      timer.startTime = effectiveStartTime;

      timer.currentTime = timer.endTime
        ? timer.endTime
        : (timer.isPaused && timer.pauseStartTime)
          ? timer.pauseStartTime
          : new Date();
    }

    const updateTimerState = (changes) => {
      this.setState(prev => ({
        timers: {
          ...prev.timers,
          [id]: {
            ...prev.timers[id],
            ...changes,
          },
        },
      }));
    };

    const showDilation = !showDilationList.has(data.appointment_status);
    return (
      data.appointment_status === "Completed" ?
        <div><Button sx={{ textTransform: 'capitalize', width: "10vw", backgroundColor: Colors.themeDark }} size='small' disableElevation variant='contained'>{t("Completed")}</Button></div> :
        data?.transfer_appointment && data?.appointment_status !== 'Cancelled' ?
          <div><Button sx={{ textTransform: 'capitalize', width: "10vw", backgroundColor: Colors.themeDark }} size='small' disableElevation variant='contained'>{"Transferred"}</Button></div> :
          data.appointment_status === "Cancelled" ?
            <Tooltip title={`Cancelled Due to ${data?.cancel_reason}`} arrow placement='top'>
              <div><Button size='small' color='error' sx={{ textTransform: 'capitalize', width: '10vw' }} variant='contained'>{t("Cancelled")}</Button></div>
            </Tooltip> :
            <Box sx={{ width: '15vw', overflowX: "auto", whiteSpace: "nowrap", height: 'auto', }}>
              <ButtonGroup size="small" sx={{ backgroundColor: '#E4F2F0', }}>
                <Tooltip title={t('Arrived')} placement='top' arrow>
                  <Button id='eMed_OP_Btn' key="Arrived" onClick={() => {
                    this.setState({
                      DisableBtn: true
                    }, () => {
                      var today = new Date()
                      var date = DateTime.fromJSDate(today).toFormat('yyyy-MM-dd')
                      var AptDate = new Date(data.appointment_date)
                      var AppointmentDate = DateTime.fromJSDate(AptDate).toFormat('yyyy-MM-dd')

                      if (date === AppointmentDate) {
                        this.postPatientStatus('Arrived', id, data.waiting_comment)
                      } else {
                        this.errorMsgFunc("Arrived status can't be changed for future or past dates.")
                      }
                    })

                  }
                  } disabled={this.state.DisableBtn || ((data.appointment_status === "Booked" || data.appointment_status === "Ip Appointment" || data.appointment_status === "On Queue") ? false : true)}>
                    <img className='eMed_OP_AptTbl_StatusCom_Icon' src={appointmentSet.has(data.appointment_status) ? ImagePaths.StatusArrivedFill.default : ImagePaths.StatusArrived.default} alt='Arrived' />
                  </Button>
                </Tooltip>
                {this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
                  <Tooltip title={t('WithNurse')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="WithNurse" onClick={() => {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('With Nurse', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, data) })
                    }
                    } disabled={((data.appointment_status === "Arrived" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor" || data.appointment_status === "With OPTOS") ? false : true) || this.state.DisableBtn}>
                      <img className='eMed_OP_AptTbl_Status_Icon' src={sliceSet(1)?.has(data.appointment_status) ? ImagePaths.StatusNurseFill.default : ImagePaths.StatusNurse.default} alt='With Nurse' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[1]?.is_checked ?
                    <Tooltip title={t('WithNurse')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="WithNurse" onClick={() => {
                        this.setState({
                          DisableBtn: true
                        }, () => { this.postPatientStatus('With Nurse', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, data) })
                      }
                      } disabled={((data.appointment_status === "Arrived" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor" || data.appointment_status === "With OPTOS") ? false : true) || this.state.DisableBtn}>
                        <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(1)?.has(data.appointment_status)) ? ImagePaths.StatusNurseFill.default : ImagePaths.StatusNurse.default} alt='With Nurse' />
                      </Button>
                    </Tooltip> : null}
                {/* For Optometry OPTOS Icon start */}
                {(this.state.totalAppointment?.with_optos > 0 && !appointmentStatus[2]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT)) ?
                  <Tooltip title={t('With OPTOS')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="WithOPTOS" onClick={() => {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('With OPTOS', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, data) })
                    }
                    }
                      disabled={((data.appointment_status === "With Nurse" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn}
                    // disabled={((data.appointment_status === "With Nurse" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn}
                    >
                      <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(2)?.has(data.appointment_status)) ? ImagePaths.OPTOSfill.default : ImagePaths.OPTOS.default} alt='With Nurse' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[2]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT) ?
                    <Tooltip title={t('With OPTOS')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="WithOPTOS" onClick={() => {
                        this.setState({
                          DisableBtn: true
                        }, () => { this.postPatientStatus('With OPTOS', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, data) })
                      }
                      }
                        disabled={((data.appointment_status === "With Nurse" || data.appointment_status === "Optometry" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn}
                      >
                        <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(2)?.has(data.appointment_status)) ? ImagePaths.OPTOSfill.default : ImagePaths.OPTOS.default} alt='With Nurse' />
                      </Button>
                    </Tooltip> : null}
                {/* For Optometry OPTOS Icon end */}

                {/* For Optometry Icon start */}
                {(this.state.totalAppointment?.optometry > 0 && !appointmentStatus[3]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT)) ?
                  <Tooltip title={t('With Optometry')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="Optometry" onClick={() => {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('Optometry', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, data) })
                    }
                    }
                      disabled={appointmentStatus[1]?.is_checked ?
                        (((data.appointment_status === "With Nurse" || data.appointment_status === "With OPTOS" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn) :
                        ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === "With OPTOS" || data.appointment_status === "With Doctor" || data?.appointment_status === "With OPTOS") ? false : true) || this.state.DisableBtn
                      }
                    // disabled={((data.appointment_status === "With Nurse" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn}
                    >
                      <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(3)?.has(data.appointment_status)) ? ImagePaths.OptometryFill.default : ImagePaths.Optometry.default} alt='With Nurse' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[3]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT) ?
                    <Tooltip title={t('With Optometry')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="Optometry" onClick={() => {
                        this.setState({
                          DisableBtn: true
                        }, () => { this.postPatientStatus('Optometry', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, data) })
                      }
                      }
                        disabled={appointmentStatus[1]?.is_checked ?
                          (((data.appointment_status === "With Nurse" || data.appointment_status === "With OPTOS" || data.appointment_status === "With Doctor") ? false : true) || this.state.DisableBtn) :
                          ((data.appointment_status === "Arrived" || data.appointment_status === "With Doctor" || data.appointment_status === "With Nurse" || data.appointment_status === "With OPTOS") ? false : true) || this.state.DisableBtn
                        }
                      >
                        <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(3)?.has(data.appointment_status)) ? ImagePaths.OptometryFill.default : ImagePaths.Optometry.default} alt='With Nurse' />
                      </Button>
                    </Tooltip> : null}
                {/* For Optometry Icon end */}
                {/* For Optometry completed start */}
                {((this.state.totalAppointment?.optometry_completed > 0 && !appointmentStatus[4]?.is_checked) || (appointmentStatus[4]?.is_checked)) && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT) ?
                  <Tooltip title={t('Optometry Completed')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="optometry_completed" onClick={() => {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('Optometry Completed', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, data) })
                    }
                    }
                      disabled={(((data.appointment_status === "Optometry") ? false : true) || this.state.DisableBtn)}
                    >
                      <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(4)?.has(data.appointment_status)) ? ImagePaths.withOptCompletedOn.default : ImagePaths.withOptCompletedOff.default} alt='Opt Complete' />
                    </Button>
                  </Tooltip> : null}
                {/* For Optometry completed end */}
                <Tooltip title={t('WithDoctor')} placement='top' arrow>
                  <Button id='eMed_OP_Btn' key="WithDoctor" onClick={() => {
                    this.setState({
                      DisableBtn: true
                    }, () => { this.postPatientStatus('With Doctor', id, data.waiting_comment, (data.waiting_timer ? null : data.timer), data.waiting_timer, data) })
                  }
                  }
                    disabled={this.state.totalAppointment?.with_nurse > 0 && !appointmentStatus[1]?.is_checked ?
                      ((data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true) || this.state.DisableBtn) :
                      appointmentStatus[1]?.is_checked ?
                        ((data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true) || this.state.DisableBtn) :
                        ((data.appointment_status === "Arrived" || data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' || data.appointment_status === "Optometry Completed" ? false : true) || this.state.DisableBtn)
                    }
                  // disabled={(data.appointment_status === "With Nurse" || data.appointment_status === 'Optometry' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true) || this.state.DisableBtn}
                  >
                    <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(5)?.has(data.appointment_status)) ? ImagePaths.StatusDoctorFill.default : ImagePaths.StatusDoctor.default} alt='With Doctor' />
                  </Button>
                </Tooltip>
                { /* for in opticals start */}
                {(this.state.totalAppointment?.in_opticals > 0 && !appointmentStatus[6]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT)) ?
                  <Tooltip title={t('In Opticals')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="InOpticals" onClick={() => {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('In Opticals', id, data.waiting_comment) })
                    }
                    }
                      disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true) || this.state.DisableBtn)}
                    // disabled={(data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn}
                    >
                      <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(6)?.has(data.appointment_status)) ? ImagePaths.InOpticals.default : ImagePaths.InOpticalsOff.default} alt='In Opticals' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[6]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT) ?
                    <Tooltip title={t('In Opticals')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="InOpticals" onClick={() => {
                        this.setState({
                          DisableBtn: true
                        }, () => { this.postPatientStatus('In Opticals', id, data.waiting_comment) })
                      }
                      }
                        disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true) || this.state.DisableBtn)}
                      // disabled={(data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn}
                      >
                        <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(6)?.has(data.appointment_status)) ? ImagePaths.InOpticals.default : ImagePaths.InOpticalsOff.default} alt='In Opticals' />
                      </Button>
                    </Tooltip> : null}
                { /* for in opticals end */}
                { /* for in opticals Completed start */}
                {(this.state.totalAppointment?.opticals_completed > 0 && !appointmentStatus[7]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT)) ?
                  <Tooltip title={t('Opticals Completed')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="OpticalsCompleted" onClick={() => {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('Opticals Completed', id, data.waiting_comment) })
                    }
                    }
                      disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true) || this.state.DisableBtn)}
                    // disabled={(data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn}
                    >
                      <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(7)?.has(data.appointment_status)) ? ImagePaths.OpticalsCompleted.default : ImagePaths.OpticalsCompletedOff.default} alt='Opticals Completed' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[7]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT) ?
                    <Tooltip title={t('Opticals Completed')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="OpticalsCompleted" onClick={() => {
                        this.setState({
                          DisableBtn: true
                        }, () => { this.postPatientStatus('Opticals Completed', id, data.waiting_comment) })
                      }
                      }
                        disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'In Opticals' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'With Counsellor' ? false : true) || this.state.DisableBtn)}
                      // disabled={(data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn}
                      >
                        <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(7)?.has(data.appointment_status)) ? ImagePaths.OpticalsCompleted.default : ImagePaths.OpticalsCompletedOff.default} alt='Opticals Completed' />
                      </Button>
                    </Tooltip> : null}
                { /* for in opticals Completed end */}
                {this.state.totalAppointment?.with_counsellor > 0 && !appointmentStatus[8]?.is_checked ?
                  <Tooltip title={t('With Counsellor')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="WithCounsellor" onClick={() => {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('With Counsellor', id, data.waiting_comment) })
                    }
                    }
                      disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'In Opticals' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'Scan/Surgery' ? false : true) || this.state.DisableBtn)}
                    // disabled={(data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn}
                    >
                      <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(8)?.has(data.appointment_status)) ? ImagePaths.withCounsellorOn.default : ImagePaths.withCounsellorOff.default} alt='With Counsellor' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[8]?.is_checked ?
                    <Tooltip title={t('With Counsellor')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="WithCounsellor" onClick={() => {
                        this.setState({
                          DisableBtn: true
                        }, () => { this.postPatientStatus('With Counsellor', id, data.waiting_comment) })
                      }
                      }
                        disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'In Opticals' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'Scan/Surgery' ? false : true) || this.state.DisableBtn)}
                      // disabled={(data.appointment_status === "With Doctor" ? false : true) || this.state.DisableBtn}
                      >
                        <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(sliceSet(8)?.has(data.appointment_status)) ? ImagePaths.withCounsellorOn.default : ImagePaths.withCounsellorOff.default} alt='With Counsellor' />
                      </Button>
                    </Tooltip> : null}

                {/* For Optometry Icon start */}
                {this.state.totalAppointment?.scan_surgery > 0 && !appointmentStatus[9]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT) ?
                  <Tooltip title={t('Scan/Surgery')} placement='top' arrow>
                    <Button id='eMed_OP_Btn' key="Scan/Surgery" onClick={() => {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('Scan/Surgery', id, data.waiting_comment) })
                    }
                    } disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'In Opticals' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'With Counsellor') ? false : true) || this.state.DisableBtn}>
                      <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(data.appointment_status === "Scan/Surgery") ? ImagePaths.ScanSurgeryFill.default : ImagePaths.ScanSurgery.default} alt='With Nurse' />
                    </Button>
                  </Tooltip> :
                  appointmentStatus[9]?.is_checked && (data.speciality === Serviceurls.ROLE_OPTOMETRY || data.speciality === Serviceurls.ROLE_OPT) ?
                    <Tooltip title={t('Scan/Surgery')} placement='top' arrow>
                      <Button id='eMed_OP_Btn' key="Scan/Surgery" onClick={() => {
                        this.setState({
                          DisableBtn: true
                        }, () => { this.postPatientStatus('Scan/Surgery', id, data.waiting_comment) })
                      }
                      } disabled={((data.appointment_status === "With Doctor" || data.appointment_status === 'In Opticals' || data.appointment_status === 'Opticals Completed' || data.appointment_status === 'With Counsellor') ? false : true) || this.state.DisableBtn}>
                        <img className='eMed_OP_AptTbl_StatusCom_Icon' src={(data.appointment_status === "Scan/Surgery") ? ImagePaths.ScanSurgeryFill.default : ImagePaths.ScanSurgery.default} alt='With Nurse' />
                      </Button>
                    </Tooltip> : null}
                {/* For Optometry Icon end */}
                <Tooltip title={t('Completed')} placement='top' arrow>
                  <Button id='eMed_OP_Btn' key="Completed" onClick={() => {
                    if (data?.dilation_details?.[0]?.status !== 'completed' && data?.dilation_details) {
                      let stopTime;
                      let shouldInsertDummyResume = false;

                      if (timer.isPaused && timer.pauseStartTime) {
                        stopTime = timer.pauseStartTime;
                        shouldInsertDummyResume = true;
                      } else {
                        stopTime = new Date();
                      }

                      this.UpdateDilationTimeUMA(id, false, true, false, false, false, shouldInsertDummyResume).then(() => {
                        updateTimerState({
                          endTime: stopTime,
                          currentTime: stopTime,
                        });
                      });
                      setTimeout(() => {
                        this.setState({
                          DisableBtn: true
                        }, () => { this.postPatientStatus('Completed', id, data.waiting_comment) })
                      }, 500);
                    } else {
                      this.setState({
                        DisableBtn: true
                      }, () => { this.postPatientStatus('Completed', id, data.waiting_comment) })
                    }
                  }}
                    disabled={(data.appointment_status === 'With Doctor' || data.appointment_status === 'Scan/Surgery' || data.appointment_status === 'In Opticals' || data.appointment_status === 'Opticals Completed' ||
                      data.appointment_status === 'With Counsellor' || (data.is_nurse && data.token_type === "Nurse"
                        && data.appointment_status === "With Nurse") ? false : true) || this.state.DisableBtn} >
                    <img className='eMed_OP_AptTbl_StatusCom_Icon' src={ImagePaths.StatusCompleted.default} alt='Completed' />
                  </Button>
                </Tooltip>
              </ButtonGroup>
              {myUser?.new_doctor_notes_template && this.state.isOPT && data.appointment_status === 'Optometry' ?
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: "0.5vw" }}>
                  {timer.originalStartTime && this.formatTimeDiff(timer.originalStartTime, timer.currentTime, timer.totalPausedMs)}
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {!timer.startTime && (
                      <Button
                        size='small'
                        variant='outlined'
                        startIcon={<PlayArrowIcon />}
                        onClick={() => {
                          const now = new Date();
                          updateTimerState({
                            startTime: now,
                            currentTime: now,
                            endTime: null,
                            isPaused: false,
                            pauseStartTime: null,
                          });
                          setTimeout(() => {
                            updateTimerState({ currentTime: new Date() });
                          }, 50);

                          this.UpdateDilationTimeUMA(id, true, false).then(success => {
                            if (success) this.getPatientDetails();
                          });
                        }}
                      >
                        Start
                      </Button>
                    )}

                    {timer.startTime && !timer.endTime && (
                      <>
                        <Tooltip title={timer.isPaused ? "Resume" : "Pause"} arrow>
                          <IconButton
                            onClick={() => {
                              if (timer.isPaused) {
                                updateTimerState({
                                  isPaused: false,
                                  pauseStartTime: null,
                                  currentTime: new Date(),
                                });
                                this.setState(prev => ({ refreshCount: prev.refreshCount + 1 }));
                                this.UpdateDilationTimeUMA(id, false, false, false, false, true).then(success => {
                                  if (success) this.getPatientDetails();
                                });
                              } else {
                                const pauseNow = new Date();
                                updateTimerState({
                                  isPaused: true,
                                  pauseStartTime: pauseNow,
                                });
                                this.setState(prev => ({ refreshCount: prev.refreshCount + 1 }));
                                this.UpdateDilationTimeUMA(id, false, false, true).then(success => {
                                  if (success) this.getPatientDetails();
                                });
                              }
                            }}
                            sx={{ p: '2px' }}
                          >
                            {timer.isPaused ? (
                              <PlayArrowIcon sx={{ fontSize: '1rem' }} />
                            ) : (
                              <PauseIcon sx={{ fontSize: '1rem' }} />
                            )}
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Reset" arrow>
                          <IconButton
                            onClick={() => {
                              this.UpdateDilationTimeUMA(id, false, false, false, true).then(success => {
                                if (success) {
                                  this.setState(prev => {
                                    const updated = { ...prev.timers };
                                    delete updated[id];
                                    return { timers: updated, refreshCount: prev.refreshCount + 1 };
                                  });
                                }
                              });
                            }}
                            sx={{ p: '2px' }}
                          >
                            <ReplayIcon sx={{ fontSize: '1rem' }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Stop" arrow>
                          <IconButton
                            onClick={() => {
                              let stopTime;
                              let shouldInsertDummyResume = false;

                              if (timer.isPaused && timer.pauseStartTime) {
                                stopTime = timer.pauseStartTime;
                                shouldInsertDummyResume = true;
                              } else {
                                stopTime = new Date();
                              }

                              this.UpdateDilationTimeUMA(id, false, true, false, false, false, shouldInsertDummyResume).then(() => {
                                updateTimerState({
                                  endTime: stopTime,
                                  currentTime: stopTime,
                                });
                              });
                            }}
                            sx={{ p: '2px' }}
                          >
                            <StopIcon sx={{ fontSize: '1rem' }} color="error" />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}

                    {timer.endTime && (
                      <Typography color="green" fontWeight={500} fontSize={'0.9vw'} display="flex" alignItems="center">
                        <CheckCircleIcon sx={{ fontSize: '1vw', mr: 0.5 }} /> Completed
                      </Typography>
                    )}
                  </Box>
                </Box>
                :
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Box display={(this.state.isOPT && FirstDilationDetails && showDilation) ? "flex" : "none"} sx={{ flexDirection: 'column', alignItems: "center", justifyContent: "space-between", height: "7vh", marginTop: '0.5vw' }}>
                    {this.renderDilationSelect(id, 0)}
                    <Box sx={{ display: 'flex', justifyContent: "space-around", alignItems: 'center' }}>
                      {FirstDilationDetails && FirstDilationDetails?.start_time && !FirstDilationDetails?.end_time ? this.calculateTimeDifference(FirstDilationDetails?.start_time, this.state.currentTime) : (FirstDilationDetails?.start_time && FirstDilationDetails?.end_time ? this.calculateTimeDifference(FirstDilationDetails?.start_time, FirstDilationDetails?.end_time) : <Typography fontSize={'0.8vw'} fontWeight={600}>{"0 Hr : 0 Min: 0 Sec"}</Typography>)}
                      {!FirstDilationDetails?.start_time ? <Button size='small' sx={{ textTransform: "capitalize", fontWeight: 600 }} onClick={() => { this.UpdateDilationTime(id, true, false, 0) }}>Start</Button> : null}
                      {FirstDilationDetails?.start_time && !FirstDilationDetails?.end_time ? <Button sx={{ textTransform: "capitalize", fontWeight: 600 }} size='small' color='error' onClick={() => { this.UpdateDilationTime(id, false, true, 0) }}>Stop</Button> : null}
                      {FirstDilationDetails?.end_time && !SecondDilationDetails ? <Button sx={{ textTransform: "capitalize", fontWeight: 600 }} size='small' color='info' onClick={() => {
                        let data = this.state.AptTblData
                        data[this.state.AptTblData.findIndex((list) => (list?.appointment_id === id))].dilation_details[1] = {
                          "dilation": "",
                          "end_time": "",
                          "start_time": ""
                        }
                        this.setState({ AptTblData: data })
                      }}>Add New</Button> : null}
                    </Box>
                  </Box>
                  <Box display={(this.state.isOPT && SecondDilationDetails && showDilation) ? "flex" : "none"} sx={{ flexDirection: 'column', alignItems: "center", justifyContent: "space-between", height: "7vh", marginTop: "0.5vw" }}>
                    {this.renderDilationSelect(id, 1)}
                    <Box sx={{ display: 'flex', justifyContent: "space-around", alignItems: 'center' }}>
                      {SecondDilationDetails && SecondDilationDetails?.start_time && !SecondDilationDetails.end_time ? this.calculateTimeDifference(SecondDilationDetails?.start_time, this.state.currentTime) : (SecondDilationDetails?.start_time && SecondDilationDetails.end_time ? this.calculateTimeDifference(SecondDilationDetails?.start_time, SecondDilationDetails.end_time) : <Typography fontSize={'0.8vw'} fontWeight={600}>{"0 Hr : 0 Min: 0 Sec"}</Typography>)}
                      {!SecondDilationDetails?.start_time ? <Button sx={{ textTransform: "capitalize", fontWeight: 600 }} size='small' onClick={() => { this.UpdateDilationTime(id, true, false, 1) }}>Start</Button> : null}
                      {SecondDilationDetails?.start_time && !SecondDilationDetails.end_time ? <Button sx={{ textTransform: "capitalize", fontWeight: 600 }} size='small' color='error' onClick={() => { this.UpdateDilationTime(id, false, true, 1) }}>Stop</Button> : null}
                    </Box>
                  </Box>
                </Box>}
            </Box>
    )
  }

  ActionBtn = (data) => {
    const { t } = this.props
    var states = this.state
    let multi_option = []
    if (data.row.appointment_status === "Booked" || data.row.appointment_status === "Ip Appointment" || data.row.appointment_status === "Arrived") {
      multi_option.push({ label: "Reschedule", value: "Reschedule" })
      multi_option.push({ label: "PrintDoctorNotes", value: "PrintDoctorNotes" })
      multi_option.push({ label: "PrintPrescription", value: "PrintPrescription" })
      multi_option.push({ label: "Customized Print", value: "CustomizedPrint" })
      multi_option.push({ label: "OpBarcode", value: "OpBarcode" })
      multi_option.push({ label: "OpCard", value: "OpCard" })
      multi_option.push({ label: "BillDetails", value: "BillDetails" })
      multi_option.push({ label: "SummaryBill", value: "SummaryBill" })
      multi_option.push({ label: "PresTem", value: "PrescriptionTemplate" })
      multi_option.push({ label: "BarCode", value: "CommonBarcode" })
      multi_option.push({ label: "MedicalRecord", value: "MedicalRecord" })
      multi_option.push({ label: "Patient Data Sheet", value: "DataSheet" })
      multi_option.push({ label: "Move to IP", value: "MovetoIP" })

      if (data?.row?.speciality === Serviceurls.ROLE_OPTOMETRY || data?.row?.speciality === Serviceurls.ROLE_OPT) {
        multi_option.push({ label: "Glass Prescription", value: "Glass Prescription" })
      }
      if (!data?.row?.transfer_appointment) {
        multi_option.push({ label: "TransAppoint", value: "TransAppoint" })
        // multi_option.push({ label: "CancelAppontment", value: "CancelAppontment" })
      }
    }
    else {
      multi_option.push({ label: "NextAppointment", value: "NextAppointment" })
      multi_option.push({ label: "PrintDoctorNotes", value: "PrintDoctorNotes" })
      multi_option.push({ label: "PrintPrescription", value: "PrintPrescription" })
      multi_option.push({ label: "Customized Print", value: "CustomizedPrint" })
      multi_option.push({ label: "OpBarcode", value: "OpBarcode" })
      multi_option.push({ label: "OpCard", value: "OpCard" })
      multi_option.push({ label: "BillDetails", value: "BillDetails" })
      multi_option.push({ label: "SummaryBill", value: "SummaryBill" })
      multi_option.push({ label: "PresTem", value: "PrescriptionTemplate" })
      multi_option.push({ label: "BarCode", value: "CommonBarcode" })
      multi_option.push({ label: "MedicalRecord", value: "MedicalRecord" })
      multi_option.push({ label: "Patient Data Sheet", value: "DataSheet" })
      multi_option.push({ label: "Move to IP", value: "MovetoIP" })

      if (data?.row?.speciality === Serviceurls.ROLE_OPTOMETRY || data?.row?.speciality === Serviceurls.ROLE_OPT) {
        multi_option.push({ label: "Glass Prescription", value: "Glass Prescription" })
      }
      // multi_option.push({ label: "TransAppoint", value: "TransAppoint" })
      if (!data?.row?.transfer_appointment) {
        multi_option.push({ label: "TransAppoint", value: "TransAppoint" })
      }
    }
    let CancelStatusList = JSON.parse(localGetItem('cancel_appointment_status')) ? JSON.parse(localGetItem('cancel_appointment_status')) : JSON.parse(localGetItem('loggedInUserInfo'))?.cancel_appointment_status ? JSON.parse(localGetItem('loggedInUserInfo'))?.cancel_appointment_status !== null ? JSON.parse(localGetItem('loggedInUserInfo'))?.cancel_appointment_status : Cancel_appointment_Status_opt : Cancel_appointment_Status_opt
    if (CancelStatusList?.find((list) => (list?.label === (data?.row?.appointment_status === 'Optometry' ? 'With Optometry' : data?.row?.appointment_status) && list?.is_checked)) || data.row.appointment_status === "Booked" || data.row.appointment_status === "Ip Appointment") {
      multi_option.push({ label: "CancelAppontment", value: "CancelAppontment" })
    }

    if (data?.row?.is_emergency) {
      multi_option?.push({ label: "Disable Highlight", value: "ChangeTag" })
    }
    var date = new Date().toISOString().split('T')[0];
    return (
      <div className='eMed_OP_Apt_ActionBtn'>
        <Tooltip title={t('CreateBill')} placement='top' arrow>
          <div>
            <IconButton disabled={(data.row.appointment_status === "Cancelled" || data.row.appointment_status === "No Show") ? true : false} onClick={() => {
              let { history } = this.props;
              if (localGetItem('isNewBilling') === 'true') {
                setCachevalue(true, 'FromOtherScreen')
                setCachevalue('/OPHome', 'path')
                setCachevalue(true, 'isForCancelBill')
                setCachevalue(true, 'FromCreate')
                history.push({ pathname: '/HospitalBilling/HospitalBilling', state: { patientId: data?.row, appointment_id: data?.row?.appointment_id } })
              } else {
                setCachevalue(JSON.stringify(data?.row), "patientData")
                history.push({ pathname: '/OPHome/PatientDetails/Billing' })
              }
            }}
            ><img className='eMed_OP_AptTbl_Status_Icon' src={(data.row.appointment_status === "Cancelled" || data.row.appointment_status === "No Show") ? ImagePaths.DisabledCreateBill.default : ImagePaths.BillCreated.default} alt='Create Bill' /></IconButton>
          </div>
        </Tooltip>
        {/* <Tooltip title={t('CancelAppontment')} placement='top' arrow>
          <div>
            <IconButton disabled={data.row.appointment_status === "Booked" || data.row.appointment_status === "Arrived" ? false : true} onClick={() => {
              this.setState({ cancelAppointment: true, SelectedPatientDetails: data.row })
            }}>
              <img className='eMed_OP_AptTbl_Status_Icon' src={data.row.appointment_status === "Booked" || data.row.appointment_status === "Arrived" ? ImagePaths.CancelAppoinment.default : ImagePaths.CancelAppDisabled.default} alt='Cancel Appointments' />
            </IconButton>
          </div>
        </Tooltip> */}
        <Tooltip title={t('Receive Payment')} placement='top' arrow>
          <div>
            <IconButton disabled={(CheckCashCounterAccess() || (localGetItem('isNewBilling') === "false")) && CheckAccessFunc("front_office", "Home", "Billing", "Bills", "SubTab")?.editAccess && data.row?.appointment_id && data.row.appointment_status !== "Cancelled" && (((data.row?.bill_amount ? data.row?.bill_amount : 0) - (data.row?.received_amount ? data.row?.received_amount : 0)) > 0) ? false : true}
              onClick={() => {
                if ((localGetItem('isNewBilling') === "true")) {
                  this.props?.history?.push({ pathname: "/HospitalBilling/CashCounter", states: { patient_details: { ...data.row, patient_account_number: data?.row?.patient_account_numbers }, return_path: "/OPHome", back_button_lable: "Back to OP Home", module: "op", search_label: "appointment_id", search_value: data.row?.appointment_id } })
                } else {
                  this.getPatientCompletedBillData(data.row)
                }
              }}>
              <img className='eMed_OP_AptTbl_Status_Icon' src={(CheckCashCounterAccess() || (localGetItem('isNewBilling') === "false")) && CheckAccessFunc("front_office", "Home", "Billing", "Bills", "SubTab")?.editAccess && data.row?.appointment_id && data.row.appointment_status !== "Cancelled" && (((data.row?.bill_amount ? data.row?.bill_amount : 0) - (data.row?.received_amount ? data.row?.received_amount : 0)) > 0) ? ImagePaths.Payment.default : ImagePaths.DisPayment.default} alt='Cancel Appointments' />
            </IconButton>
          </div>
        </Tooltip>
        <div>
          <Tooltip title={t("More")} placement='top' arrow>
            <IconButton
              onClick={(e) => {
                this.setState({

                  anchorEl: e.currentTarget,
                  selectedRow: data.id,
                  isSelected: true
                })
              }}
              disabled={(data.row.appointment_status === "Cancelled" || data.row.appointment_status === "No Show") ? true : false}
            >
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
          {(this.state.isSelected && this.state.selectedRow == data.id) ?
            <Menu
              anchorEl={this.state.anchorEl}
              open={Boolean(this.state.anchorEl)}
              onClose={() => {
                this.setState({ anchorEl: null, })
              }}
            >
              {multi_option.map((option) => (
                <MenuItem key={option}
                  disabled={(((data.row.appointment_status !== "Completed" && data.row.appointment_status !== "With Doctor") || data.row.is_nurse)
                    && (option.label === "PrintDoctorNotes" || option.label === "PrintPrescription"))
                    || option?.value === "MovetoIP" && (new Date(data.row.appointment_date).toISOString().split('T')[0] !== date ||
                      (data.row.ip_request_status !== "not_initiated" && data.row.ip_request_status !== "rejected"))
                    || (data.row.is_nurse && option.label === "PresTem")
                    || (option.label === "TransAppoint" && data.row.appointment_status === "Completed")
                    || (this.state.selectedOption === option.value)
                    || (option?.label === 'TransAppoint' && (data?.row?.doctor_name === '' || data?.row?.doctor_name === "  "))
                    || (option.label === "TransAppoint" && data.row.patient_appointment_types === "Tele Consultation")
                    ? true : false}
                  onClick={() => { this.setState({ selectedOption: option.value, anchorEl: null, SelectedPatientDetails: data.row, tokenNum: data.row.token_number }) }}>
                  {t(option.label)}
                </MenuItem>
              ))}
            </Menu> : null}
        </div>
      </div>
    )
  }

  routeToDemograhics = (params) => {
    let { history } = this.props;
    setCachevalue(JSON.stringify(params?.row), "patientData")
    setCachevalue(JSON.stringify(this.state.datePicker), "SelectedOPDate")
    if (params.field === "patientDetails" || (params.field === "purpose_of_visit" && !this.state.onChangePov) || params.field === "appointment_start_time" || params.field === "bill_amount" || (params.field === "token_number" && !this.state.onAddComment)) {
      history.push({ pathname: "/OPHome/PatientDetails/Demographics" })
    }
  }
  handleClose = () => {
    this.setState({
      waitingCmts: false
    })
  }

  addComments = (value) => {
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    var states = this.state
    if (this.state.waitCmtText) {
      var data1 = value.waiting_comment
      var data2 = []
      var date = new Date()
      var options = { timeZone: 'Asia/Kolkata', hour12: true, hour: 'numeric', minute: 'numeric' }
      var timeString = date.toLocaleTimeString('en-IN', options)
      data2.push({
        "date": DateTime.fromJSDate(date).toFormat('dd-MM-yyyy'),
        "time": timeString,
        "comments": states.waitCmtText.replace(/\s+/g, ' ').trim(),
        "user_name": myUser?.display_name,
        "appointment_status": value?.appointment_status,
      })
      var cmtData = [...data1, ...data2]
      this.setState({
        waitingCmts: false,
      })
      this.postPatientStatus('', states.SelectedPatientDetails.appointment_id, cmtData)
    } else {
      this.errorMsgFunc('Please Enter The Comment')
    }
  }

  povPopClose = () => {
    this.setState({
      povText: {},
      ispovPopOpen: false,
      onChangePov: false,
    })
  }

  renderWaitingCmt = (data) => {
    const { t } = this.props
    var states = this.state
    return (
      (states.SelectedPatientDetails.patient_id == data.patient_id && states.SelectedPatientDetails?.appointment_id === data.appointment_id) ?
        <Dialog
          open={this.state.waitingCmts}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className="eMed_DialogBox_Title" style={{ padding: '0.5vw' }}>
            <div>
              {t("WaitingComments")}
            </div>
            <div className="eMed_DialogBox_Close">
              <img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt='Close' onClick={() => { this.setState({ waitingCmts: false, waitCmtText: '' }) }} />
            </div>
          </div>
          {
            data.appointment_status !== "Completed" ?
              <div>
                <DialogContent>
                  <TextField
                    sx={{ width: '25vw' }}
                    multiline
                    inputProps={{ maxLength: cmt_Char_limit }}
                    rows={3}
                    placeholder={t("AddComments")}
                    variant="outlined"
                    value={this.state.waitCmtText}
                    onChange={(e) => {
                      this.setState({ waitCmtText: e.target.value })
                    }} />
                </DialogContent>
                <DialogActions id="eMed_DialogBox_Btn">
                  <Button size="small" variant='outlined' id="eMed_Dia_Btn" onClick={() => { this.setState({ waitCmtText: '' }) }}>
                    {t('Clear')}
                  </Button>
                  <Button size="small" variant='contained' id="eMed_Dia_Btn" onClick={() => { this.addComments(data) }}>
                    {t('Add')}
                  </Button>

                </DialogActions>
              </div> : null
          }
          {data.waiting_comment.length > 0 ?
            <DialogContent id='eMed_OP_oldComments_Con'>
              <div className='eMed_OP_oldComments_Con1'>
                {data?.waiting_comment.map((item) => (
                  <div style={{ height: 'auto' }} >
                    <p className='eMed_OP_Cmts_Text'>{item.comments}</p>
                    <p className='eMed_OP_Cmts_Text1'>{item.time + ' | ' + item.date}</p>
                    <hr />
                  </div>
                ))}
              </div>
            </DialogContent> :
            <DialogContent id='eMed_OP_no_comments_div'>
              <Typography className='eMed_OP_no_comments_txt'>No Comments</Typography>
            </DialogContent>}
        </Dialog> : null
    )
  }
  waitTime = (data, id) => {
    var { AptTblData } = this.state;

    const convertTime12to24 = moment(data.patient_arrived_time, ["h:mm A"]).format("HH:mm");
    var year = moment(new Date(data.appointment_date)).format("LL") + " " + convertTime12to24 + ":00"
    var currnet_date = new Date();
    var arrived_date = new Date(year);
    var res = Math.abs(currnet_date - arrived_date) / 1000;
    var days = Math.floor(res / 86400);
    var hours = Math.floor(res / 3600) % 24;
    var minutes = Math.floor(res / 60) % 60;
    var seconds = res % 60;

    // const newDate = new Date().toLocaleTimeString('en-US', { hour12: false, })
    // var startTime = moment(data.patient_arrived_time != null ? ":00 PM" : '', "HH:mm:ss");
    // var endTime = moment(newDate, "HH:mm:ss");
    // var duration = moment.duration(endTime.diff(startTime));
    // var hours = parseInt(duration.asHours());
    // var minutes = parseInt(duration.asMinutes()) - hours * 60;
    var result = hours + ' Hr ' + minutes + ' Mins.'
    var time = data.patient_arrived_time ? "Arrived: " + data.patient_arrived_time + " | " + (data.waiting_timer ? data.waiting_timer : result) : "-"

    AptTblData && AptTblData.length > 0 && (AptTblData).map((element, index) => {
      if (id === element.patient_id && element.timer != result && element.timer === undefined) {
        AptTblData[index]["timer"] = result === "NaN Hr NaN Mins." ? "0 Hr 0 Mins." : result
        this.setState({
          AptTblData
        })
      }
    })
    return (
      <Typography id='eMed_OP_AptTbl_AptText1' fontWeight={'bold'}>{time}</Typography>
    )
  }

  numberSort = (v1, v2) => {
    let sorted = gridNumberComparator(v1, v2);
    return sorted;
  }
  startCallApi = (id, data) => {
    try {
      this.setState({ loading: true })
      RestAPIService.GetWithoutReplica(`${Serviceurls.TELE_START_CALL}?appointment_id=${id}`)
        .then((response) => {
          if (response.data.status === 'success') {
            // Pass all data as URL parameters
            const channel = response.data.data.channel || '';
            let queryParams = "";
            if (channel) {
              queryParams = new URLSearchParams({
                patientName: data.patient_name,
                channelName: channel || '',
                appoinID: id,
                userRole: 'patient',
              }).toString();
            } else {
              this.errorMsgFunc('Please try again later, Channel not created.');
            }
            const popup = window.open(`/video-call?${queryParams}`, "_blank");
            this.setState({ loading: false, DisableBtn: false })
          }
        })
        .catch((e) => {
          this.setState({ loading: false, DisableBtn: false })
          this.errorMsgFunc(e.response?.data?.message || e.message)
        })
    } catch (e) {
      this.setState({ loading: false, DisableBtn: false })
      this.errorMsgFunc(e.message)
    }
  }
  telemedicineBtns = (data, id) => {
    const { t } = this.props
    return (
      data.appointment_status === "Completed" ?
        <div><Button sx={{ textTransform: 'capitalize', width: "10vw", backgroundColor: Colors.themeDark }} size='small' disableElevation variant='contained'>{t("Completed")}</Button></div> :
        <Box>
          <Tooltip title={t('Arrived')} placement='top' arrow>
            <Button id='eMed_OP_Btn' key="Arrived" onClick={() => {
              this.setState({
                DisableBtn: true
              }, () => {
                var today = new Date()
                var date = DateTime.fromJSDate(today).toFormat('yyyy-MM-dd')
                var AptDate = new Date(data.appointment_date)
                var AppointmentDate = DateTime.fromJSDate(AptDate).toFormat('yyyy-MM-dd')

                if (date === AppointmentDate) {
                  this.postPatientStatus('Arrived', id, data.waiting_comment)
                } else {
                  this.errorMsgFunc("Arrived status can't be changed for future or past dates.")
                }
              })

            }
            } disabled={this.state.DisableBtn || ((data.appointment_status === "Booked" || data.appointment_status === "Ip Appointment" || data.appointment_status === "On Queue") ? false : true)}>
              <img style={{ width: '1.5vw', height: '1.5vw' }} src={data.appointment_status === 'Arrived' ? ImagePaths.StatusArrivedFill.default : ImagePaths.StatusArrived.default} alt='Arrived' />
            </Button>
          </Tooltip>
          <Tooltip title={t('Call')} placement='top' arrow>
            <Button id='eMed_OP_Btn' key="Call" onClick={() => {
              this.setState({
                DisableBtn: true
              }, () => {
                this.startCallApi(id, data)
              })

            }
            } disabled={(data.appointment_status === "Arrived" ? false : true)}>
              <img style={{ width: '2vw', height: '2vw' }} src={data.appointment_status === 'Arrived' ? ImagePaths.StatusCallFill.default : ImagePaths.StatusCall.default} alt='Call' />
            </Button>
          </Tooltip>
          <Tooltip title={t('Completed')} placement='top' arrow>
            <Button id='eMed_OP_Btn' key="Completed" onClick={() => {
              this.setState({
                DisableBtn: true
              }, () => { this.postPatientStatus('Completed', id, data.waiting_comment) })
            }}
              disabled={(data.appointment_status === 'Arrived' ? false : true) || this.state.DisableBtn} >
              <img style={{ width: '1.5vw', height: '1.5vw' }} src={ImagePaths.StatusCompleted.default} alt='Completed' />
            </Button>
          </Tooltip>
        </Box>
    )
  }
  renderAptTable = () => {
    const { t } = this.props
    var myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    const appointmentStatusFromStorage = JSON.parse(localGetItem('appointment_status'));
    const loggedInUserInfo = myUser?.appointment_status;
    const appointmentStatus = appointmentStatusFromStorage || (loggedInUserInfo !== null ? loggedInUserInfo : appointment_Status_opt);
    const checkedCount = appointmentStatus?.filter(item => item.is_checked).length;

    var UserData = myUser
    let isPovEdit = myUser?.is_user ? (myUser?.permission_access?.op?.is_pov_editable || false) : true;

    const columns = UserData?.module_name !== 'nurse' ? [
      {
        field: 'patientDetails', headerName: t('Patient Details'), headerClassName: 'eMed_Apt_TblHead', flex: 0.170,
        renderCell: (params) => (
          <NewCommonPatientDetails data={params.row} showTag={true} fromOp={true} />
        ), density: 'compact'
      },
      {
        field: 'token_number', headerName: t('AppointmentDetails'), headerClassName: 'eMed_Apt_TblHead', flex: 0.130, density: 'compact',
        renderCell: (params) => {
          let priorityLvl = params?.row?.appointment_type_priority ? params?.row?.appointment_type_priority : ''
          let bgColor = priorityLvl === "Priority_Level_1" ? "#1E972A" : priorityLvl === "Priority_Level_2" ? "#0461B7" : priorityLvl === "Priority_Level_3" ? "#DE7D24" : ''
          return (
            <div>
              {/* <div className='eMed_OP_PatientType'> <Typography id='eMed_OP_AptTbl_AptText' sx={{ fontWeight: '600', color: bgColor ? 'white' : 'black', backgroundColor: bgColor, padding: bgColor ? '0.2vw' : '0', borderRadius: bgColor ? '0.4vw' : '0' }}>{'Token :' + (params.row.token_number ? params.row.token_number : '-')}</Typography> <div>{this.AppointmentTypeIcon(params.row.is_transfered ? "transfer" : params.row.patient_appointment_types)}</div></div> */}
              <div className='eMed_OP_PatientType'> <Typography id='eMed_OP_AptTbl_AptText' sx={{ fontWeight: '600', color: bgColor ? 'white' : 'black', backgroundColor: bgColor, padding: bgColor ? '0.2vw' : '0', borderRadius: bgColor ? '0.4vw' : '0' }}>{'Token :' + (params.row.token_number ? params.row.token_number : '-')}</Typography>
                <div>{this.AppointmentTypeIcon(params.row.patient_appointment_types)}</div>
                {params.row.is_transfered ? this.AppointmentTypeIcon(params.row.is_transfered ? "transfer" : null) : null}
                {/* {params?.row?.session_position ? <Typography sx={{fontSize: '0.9vw', marginLeft: '.5vw'}}>{`(${params?.row?.session_position})`}</Typography> : null} */}
              </div>
              <div className='eMed_OP_AptTbl_Comment'>
                {(params.row.waiting_comment.length > 0 && params.row.waiting_comment[params.row.waiting_comment.length - 1].comments) ? (params.row.waiting_comment[params.row.waiting_comment.length - 1].comments).length > 14 ?
                  <Tooltip title={params.row.waiting_comment[params.row.waiting_comment.length - 1].comments} placement='top' arrow>
                    <Typography id='eMed_OP_AptTbl_AptText1'>{'WC : ' + params.row.waiting_comment[params.row.waiting_comment.length - 1].comments.slice(0, 12) + '...'}</Typography>
                  </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText1'>{'WC : ' + params.row.waiting_comment[params.row.waiting_comment.length - 1].comments}</Typography>
                  : null
                }
                <Tooltip title={'Add Comments'} placement='top' arrow>
                  <div onClick={() => { this.setState({ waitingCmts: true, SelectedPatientDetails: params.row }) }} onMouseOver={() => { this.setState({ onAddComment: true }) }} onMouseLeave={() => { this.setState({ onAddComment: false }) }}>{(params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") ? null : <img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.Comments.default} alt='Comments' />}</div>
                </Tooltip>
                {this.state.waitingCmts ? this.renderWaitingCmt(params.row) : null}
              </div>
              <div>{params.row.doctor_name?.length > 12 ?
                <Tooltip title={params.row.doctor_name} placement={'top'} arrow>
                  <Typography id='eMed_OP_AptTbl_AptText'>{'Consultant :' + (params.row.doctor_name ? params.row.doctor_name.slice(0, 12) + '...' : '-')}</Typography>
                </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText'>{(params.row?.is_nurse) ? 'Nurse :' + (params.row.nurse_name ? params.row.nurse_name : '-') : 'Consultant :' + (params.row.doctor_name ? params.row.doctor_name : '-')}</Typography>} </div>

            </div>)
        }, valueGetter: (params) => params.row.token_number, sortComparator: this.numberSort, sortingOrder: ['asc', 'desc']
      },
      {
        field: 'appointment_start_time', headerName: t('Arriving/WaitingTime'), headerClassName: 'eMed_Apt_TblHead', flex: 0.136, density: 'compact',
        renderCell: (params) => (
          <div>
            {this.waitTime(params.row, params.row.patient_id)}
            <Typography id='eMed_OP_AptTbl_AptText1'>{`Booked: ${params.row.appointment_start_time}`}</Typography>
          </div>
        )
      },
      {
        field: 'bill_amount', headerName: t('PaymentStatus'), headerClassName: 'eMed_Apt_TblHead', flex: 0.125, density: 'compact',
        renderCell: (params) => (
          <div>{this.PaymentStatus(params.row?.bill_amount ? params.row?.bill_amount : 0, params.row?.received_amount ? params.row?.received_amount : 0, params.row?.balance_details ? params.row?.balance_details : [])}</div>)
      },
      {
        field: 'purpose_of_visit', headerName: t('PurposeOfVisit'), headerClassName: 'eMed_Apt_TblHead', flex: 0.100, density: 'compact',
        renderCell: (params) => (
          <Box width={"100%"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
            {params.row.purpose_of_visit?.length > 16 ?
              <Tooltip title={params.row.purpose_of_visit} placement='top' arrow>
                <Typography>{params.row.purpose_of_visit.slice(0, 15) + '...'}</Typography>
              </Tooltip> : <Typography>{params.row.purpose_of_visit ? params.row.purpose_of_visit : "-"}</Typography>
            }
            {(isPovEdit && params.row.appointment_status !== "Cancelled" && params.row.appointment_status !== "Completed") ?
              <Tooltip title={'Edit'} placement='top' arrow>
                <div emed_tid={"fo_pov_edit"} size="small"
                  onClick={() => this.setState({
                    povText: params.row,
                    ispovPopOpen: true,
                  })}
                  onMouseOver={() => { this.setState({ onChangePov: true }) }}
                  onMouseLeave={() => { this.setState({ onChangePov: false }) }}>
                  <img src={ImagePaths.UserEditOn.default} className='eMed_list_image' alt='edit' />
                </div>
              </Tooltip> : null}
          </Box>)
      },
      {
        field: 'appointment_status', headerName: t('status'), headerClassName: 'eMed_Apt_TblHead', flex: 0.15, density: 'compact',
        renderCell: ({ row }) => (
          <Box display={'flex'} gap={'0.3vw'} justifyContent={'center'} width={'100%'}>
            <div>{row?.patient_appointment_types === 'Tele Consultation' ? this.telemedicineBtns(row, row.appointment_id) : this.StatusBtns(row, row.appointment_id)}</div>
            {row?.appointment_change_status ? <Tooltip title={`Request for ${row?.appointment_change_status}` + (row?.appointment_change_status === "Reschedule" ? ` - Date: ${row?.appointment_changed_date ? row?.appointment_changed_date?.slice(0, 10)?.split('-')?.reverse()?.join('-') : '-'}` : row?.appointment_change_status === "Cancelled" ? ` - Reason: ${row?.reason_for_change}` : '')} placement='top' arrow><IconButton><img src={ImagePaths.Info.default} alt='Info' style={{ width: "1.2vw", height: "1.2vw" }} /></IconButton></Tooltip> : null}
          </Box>
        )
      },
      {
        field: 'action', headerName: t('Action'), headerClassName: 'eMed_Apt_TblHead', flex: 0.09, headerAlign: 'center', density: 'compact', sortable: false, hideable: false,
        renderCell: (params) => (
          <div>{this.ActionBtn(params)}</div>
        )
      }
    ] : [
      {
        field: 'patientDetails', headerName: t('Patient Details'), headerClassName: 'eMed_Apt_TblHead', flex: 0.170,
        renderCell: (params) => (
          <CommonPatientDetails data={params.row} showTag={true} fromOp={true} hideInsurance={true} />
        ), density: 'compact'
      },
      {
        field: 'token_number', headerName: t('AppointmentDetails'), headerClassName: 'eMed_Apt_TblHead', flex: 0.140, density: 'compact',
        renderCell: (params) => {
          let priorityLvl = params?.row?.appointment_type_priority ? params?.row?.appointment_type_priority : ''
          let bgColor = priorityLvl === "Priority_Level_1" ? "#1E972A" : priorityLvl === "Priority_Level_2" ? "#0461B7" : priorityLvl === "Priority_Level_3" ? "#DE7D24" : ''
          return (
            <div>
              <div className='eMed_OP_PatientType' style={{ backgroundColor: bgColor, justifyContent: bgColor ? 'center' : '' }}> <Typography id='eMed_OP_AptTbl_AptText' sx={{ fontWeight: '600' }}>{'Token :' + (params.row.token_number ? params.row.token_number : '-')}</Typography> <div>{this.AppointmentTypeIcon(params.row.appointment_patient_type === "transfer" ? params.row.appointment_patient_type : params.row.patient_appointment_types)}</div></div>
              <div className='eMed_OP_AptTbl_Comment'>
                {(params.row.waiting_comment.length > 0 && params.row.waiting_comment[params.row.waiting_comment.length - 1].comments) ? (params.row.waiting_comment[params.row.waiting_comment.length - 1].comments).length > 14 ?
                  <Tooltip title={params.row.waiting_comment[params.row.waiting_comment.length - 1].comments} placement='top' arrow>
                    <Typography id='eMed_OP_AptTbl_AptText1'>{'WC : ' + params.row.waiting_comment[params.row.waiting_comment.length - 1].comments.slice(0, 12) + '...'}</Typography>
                  </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText1'>{'WC : ' + params.row.waiting_comment[params.row.waiting_comment.length - 1].comments}</Typography>
                  : <Typography id='eMed_OP_AptTbl_AptText1'>{"WC :  - "}</Typography>
                }
                <Tooltip title={'Add Comments'} placement='top' arrow>
                  <div onClick={() => { this.setState({ waitingCmts: true, SelectedPatientDetails: params.row }) }} onMouseOver={() => { this.setState({ onAddComment: true }) }} onMouseLeave={() => { this.setState({ onAddComment: false }) }}>{(params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") ? null : <img className='eMed_OP_Patient_Iconcircle' src={ImagePaths.Comments.default} alt='Comments' />}</div>
                </Tooltip>
                {this.state.waitingCmts ? this.renderWaitingCmt(params.row) : null}
              </div>
              <div>{params.row.doctor_name?.length > 12 ?
                <Tooltip title={params.row.doctor_name} placement={'top'} arrow>
                  <Typography id='eMed_OP_AptTbl_AptText'>{'Consultant :' + (params.row.doctor_name ? params.row.doctor_name.slice(0, 12) + '...' : '-')}</Typography>
                </Tooltip> : <Typography id='eMed_OP_AptTbl_AptText'>{'Consultant :' + (params.row.doctor_name ? params.row.doctor_name : '-')}</Typography>} </div>

            </div>)
        }, valueGetter: (params) => params.row.token_number, sortComparator: this.numberSort, sortingOrder: ['asc', 'desc']
      },
      {
        field: 'appointment_start_time', headerName: t('Arriving/WaitingTime'), headerClassName: 'eMed_Apt_TblHead', flex: 0.136, density: 'compact',
        renderCell: (params) => (
          <div>
            {this.waitTime(params.row, params.row.patient_id)}
            <Typography id='eMed_OP_AptTbl_AptText1' fontWeight={'bold'}>{`Booked: ${params.row.appointment_start_time}`}</Typography>
          </div>
        )
      },
      {
        field: 'bill_amount', headerName: t('PaymentStatus'), headerClassName: 'eMed_Apt_TblHead', flex: 0.125, density: 'compact',
        renderCell: (params) => (
          <div>{this.PaymentStatus(params.row?.bill_amount ? params.row?.bill_amount : 0, params.row?.received_amount ? params.row?.received_amount : 0)}</div>)
      },
      {
        field: 'purpose_of_visit', headerName: t('PurposeOfVisit'), headerClassName: 'eMed_Apt_TblHead', flex: 0.124, density: 'compact',
        renderCell: (params) => (
          <div>
            {params.row.purpose_of_visit?.length > 18 ?
              <Tooltip title={params.row.purpose_of_visit} placement='top' arrow>
                <Typography>{params.row.purpose_of_visit.slice(0, 18) + '...'}</Typography>
              </Tooltip> : <Typography>{params.row.purpose_of_visit ? params.row.purpose_of_visit : "-"}</Typography>
            }
          </div>)
      },
      {
        field: 'appointment_status', headerName: t('status'), headerClassName: 'eMed_Apt_TblHead', flex: checkedCount > 5 && checkedCount <= 8 ? 0.24 : 0.15, density: 'compact',
        renderCell: (params) => (
          <div>{params.row?.patient_appointment_types === 'Tele Consultation' ? this.telemedicineBtns(params.row, params.row.appointment_id) : this.StatusBtns(params.row, params.row.appointment_id)}</div>
        )
      },
      // {
      //   field: 'action', headerName: t('Action'), headerClassName: 'eMed_Apt_TblHead', flex: 0.107, headerAlign: 'center', density: 'compact', sortable: false, hideable: false,
      //   renderCell: (params) => (
      //     <div>{this.ActionBtn(params)}</div>
      //   )
      // }
    ]
    this.state.AptTblData.forEach((element, index) => { element.sno = index + 1 })
    return (

      <div>
        <Box sx={{ position: "relative" }} className='eMed_AptTbl_Con'>
          {localGetItem('show_patient_tag_filter') === 'true' ?
          
            <Box
              sx={{
                position: "absolute",
                top: "1vw",
                zIndex: 10,
                width: "54%",
                overflowX: "auto",
                whiteSpace: "nowrap",
                display: "flex",
              }}
            >
             { this.state?.tagData.length > 0 && (
               <Tabs
               value={this.state.SelectedPatientTags[0]?.patient_tag_name || false}
                // value={this.state.tagFilter}
                onChange={(e, newValue) => {
                  const current = this.state.SelectedPatientTags
                  console.log(newValue,current,"newValue")
                  if (current === newValue) {
                    this.setState(
                      {
                        SelectedPatientTags: [],
                        tabClick: false,
                      },
                      () => this.getPatientDetails()
                    );
                  }
                  else {
                    this.setState(
                      {
                        SelectedPatientTags: [{ patient_tag_name: newValue }],
                        tabClick: true
                      },
                      () => this.getPatientDetails()
                    );
                  }
                }}

                variant="scrollable"
                scrollButtons='auto'
                allowScrollButtonsMobile
                sx={{
                  "& .MuiTabs-indicator": {
                    display: "none",
                  },
                  "& .MuiTabs-scrollButtons": {
                    width: "1.8vw",
                    height: "1.8vw",
                    borderRadius: "50%",
                    background: "#fff",
                    boxShadow: "0px 0px 4px rgba(0,0,0,0.2)",
                    margin: "0 4px",
                    color: "#444",
                  },

                  "& .MuiTabs-scrollButtons:hover": {
                    background: "#f0f0f0",
                  },

                  "& .MuiTabs-scrollButtons.Mui-disabled": {
                    opacity: 0.3,
                  },
                  marginLeft: '0.4vw',

                }}
              >

                {this.state?.tagData.length > 0 && this.state?.tagData.map((tag) => (
                  <Tab
                    key={tag?.patient_tag_name}
                    value={tag?.patient_tag_name}
                    label={
                      tag?.patient_tag_name?.length > 20 ? (
                        <Tooltip arrow placement="top" title={tag?.patient_tag_name}>
                          <Box sx={{ fontSize: "0.8vw" }}>{tag?.patient_tag_name?.slice(0, 20) + "..."}{" "}({tag?.count})</Box>
                        </Tooltip>
                      ) : (
                        <Box sx={{ fontSize: "0.8vw" }}>{tag?.patient_tag_name}{" "}({tag?.count})</Box>
                      )
                    }
                    sx={{
                      minHeight: "2vw",
                      height: "2vw",
                      fontSize: "0.8vw",
                      fontWeight: 600,
                      padding: "0vw 1vw",
                      borderRadius: "5px",
                      textTransform: "none",
                      marginRight: "0.5vw",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: `1px solid ${tag?.patient_tag_color}`,
                      background: "white",
                      color: tag?.patient_tag_color,
                      "&.Mui-selected": {
                        color: "white",
                        background: tag?.patient_tag_color,
                        border: `1px solid ${tag?.patient_tag_color}`,
                      },
                    }}                    
                  />

                ))}
              </Tabs>
             ) }
             
              {this?.state.tabClick && (
                <IconButton onClick={() => { this.setState({ SelectedPatientTags: [], tabClick: false }, () => this.getPatientDetails()) }} sx={{
                  minHeight: "2vw",   
                  height: "2vw",
                  fontSize: "0.8vw",
                  fontWeight: 600,
                  padding: "0vw 1vw",
                  // borderRadius: "50%",
                  textTransform: "none",
                  marginRight: "0.5vw",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: `1px solid red`,
                  background: "white",
                  color: "red",
                  cursor: "pointer",
                  width: "0.8vw",
                  height: "0.8vw",
                }}>
                  <Tooltip arrow title={t("Clear")} placement="right">
                    <img style={{
                      width: "0.8vw",
                      height: "0.8vw",
                      objectFit: "contain",
                      filter: "invert(26%) sepia(98%) saturate(7444%) hue-rotate(357deg) brightness(93%) contrast(102%)"
                    }} src={ImagePaths.LabCloseButton.default} alt="close" />
                  </Tooltip>

                </IconButton>
              )}

            </Box>

            : null}






          <DataGrid
            rows={this.state.AptTblData}
            columns={columns}
            getRowId={(row) => row['sno']}
            pageSize={this.state.pageSize}
            page={this.state.page}
            rowsPerPageOptions={[10, 20, 30, 50]}
            components={{
              Toolbar: CommonGridHeader.CommonToolBar,
              NoRowsOverlay: () => (
                <Stack className='eMed_conf_nodata'>
                  {t("NoRecordsFound")}
                </Stack>

              )
            }}
            localeText={{
              toolbarColumns: "",
              toolbarDensity: "",
              toolbarExport: "",
              toolbarFilters: "",
              toolbarExportPrint: ""
            }}
            density={'compact'}
            rowHeight={100}
            onCellClick={(params) => (params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") ? null : this.routeToDemograhics(params)}
            pagination
            getRowHeight={(params) => {
              if (this.state.isOPT && !showDilationList.has(params?.model?.appointment_status) && params?.model?.transfer_appointment === false) {
                if (params?.model?.dilation_details && params?.model?.dilation_details?.length > 1) {
                  return 185
                } else {
                  return 140
                }
              } else {
                return 80
              }
            }}
            onPageChange={(newPage) => { this.setState({ page: newPage }) }}
            onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }) }}
            disableSelectionOnClick
            loading={this.state.isLoader}
            getRowClassName={(params) => {
              if (params.row.appointment_status === "Cancelled" || params.row.appointment_status === "No Show") {
                return 'eMed_OP_CancelPatient'
              } else {
                return null
              }
            }}
          />
        </Box>
      </div>
    )
  }
  NxtAppiontmentClose() {
    setTimeout(() => { this.setState({ selectedOption: "" }) }, 1000)
  }
  NxtAppointmentSuccess(message) {
    this.setState({ selectedOption: "" }, () => {
      this.successMsgFunc(message)

      var dilation = this.state.SelectedPatientDetails?.dilation_details?.[0] || {};
      var id = this.state.SelectedPatientDetails?.appointment_id
      if (this.state.SelectedPatientDetails?.dilation_details?.[0]?.status !== 'completed' && this.state.SelectedPatientDetails?.dilation_details) {
        const timers = this.state.timers || {};
        let timer = timers[id] || {
          originalStartTime: dilation.start_time ? new Date(dilation.start_time) : null,
          endTime: dilation.end_time ? new Date(dilation.end_time) : null,
          isPaused: dilation.is_paused ?? false,
          pauseStartTime: dilation.pause_time ? new Date(dilation.pause_time) : null,
          totalPausedMs: 0,
          currentTime: new Date(),
          startTime: dilation.start_time ? new Date(dilation.start_time) : null,
        };
        let stopTime;
        let shouldInsertDummyResume = false;
        if (timer.isPaused && timer.pauseStartTime) {
          stopTime = timer.pauseStartTime;
          shouldInsertDummyResume = true;
        } else {
          stopTime = new Date();
        }
        this.UpdateDilationTimeUMA(id, false, true, false, false, false, shouldInsertDummyResume).then(() => {
          this.setState(prev => ({
            timers: {
              ...prev.timers,
              [id]: {
                ...prev.timers[id],
                endTime: stopTime,
                currentTime: stopTime,
              },
            },
          }));
        });
        setTimeout(() => {
          this.getPatientDetails()
        }, 500);
      } else {
        this.getPatientDetails()
      }
    })
  }

  closemoveIp = () => {
    this.setState({
      selectedOption: "",
      anchorEl: null,
      SelectedPatientDetails: {},
      tokenNum: '',
      moveIpPopup: false
    })
  }

  confirmSaveOpToIp = () => {
    try {
      let data = {
        appointment_id: this.state.SelectedPatientDetails?.appointment_id,
      }
      RestAPIService.create(data, Serviceurls.OP_TO_IP_MOVE)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMsgFunc(response.data.message)
            this.setState({ moveIpPopup: false })
            this.getPatientDetails()
            this.closemoveIp()
          }
        }).catch((error) => {
          this.errorMsgFunc(error?.response?.data?.message || error.message)
          this.closemoveIp()
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
      this.closemoveIp()
    }
  }

  renderNxtApointmtPopup = () => {
    const { selectedOption, SelectedPatientDetails } = this.state;
    const commonProps = {
      PostSuccess: this.NxtAppointmentSuccess.bind(this),
      NxtAppiontmentClose: this.NxtAppiontmentClose.bind(this),
      PatientDetails: SelectedPatientDetails,
    };

    switch (selectedOption) {
      case "NextAppointment":
        return <NextAppointments {...commonProps} ScreenName="NextAppointment" />;
      case "Reschedule":
        return <NextAppointments {...commonProps} ScreenName="RescheduleAppiontment" />;
      case "PrintDoctorNotes":
        this.getPatientDoctorNotesPrint();
        break;
      case "PrintPrescription":
        this.getPatientPrescriptionPrint();
        break;
      case "CustomizedPrint":
        this.getCustomizedCardPrint();
        break;
      case "OpBarcode":
        this.getPatientOpCardPrint(false);
        break;
      case "OpCard":
        this.getPatientOpCardPrint(true);
        break;
      case "BillDetails":
        this.getPatientOpBillDetailPrint();
        break;
      case "SummaryBill":
        this.getPatientOpSummaryBillPrint();
        break;
      case "PrescriptionTemplate":
        this.getPatientPresTemplate();
        break;
      case "CommonBarcode":
        this.getCommonBarCodePrint();
        break;
      case "MedicalRecord":
        this.getMedicalRecordPrint();
        break;
      case "CancelAppontment":
        this.setState({ cancelAppointment: true, selectedOption: "" });
        break;
      case "ChangeTag":
        this.postChangeTagNormal();
        break;
      case "DataSheet":
        this.OPPatientDataSheetPrint();
        break;
      case "MovetoIP":
        this.setState({ moveIpPopup: true })
        break;
      case 'Glass Prescription':
        this.getGlassPrescriptionPrint();
        break;
      default:
        return null
    }
    this.setState({ selectedOption: "" });
  }

  postChangeTagNormal = () => {
    try {
      let data = {
        appointment_id: this.state.SelectedPatientDetails?.appointment_id,
        is_emergency: false
      }
      RestAPIService.create(data, Serviceurls.FO_IP_OP_PATIENT_TAG_CHANGE_NORMAL)
        .then((response) => {
          if (response?.data?.status === 'Success') {
            this.successMsgFunc(response.data.message)
            this.getPatientDetails()
            this.setState({ selectedOption: "" })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ selectedOption: "" })
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.errorMsgFunc(error.message)
            this.setState({ selectedOption: "" })
          }
        })
    } catch (error) {
      this.setState({ selectedOption: "" })
      this.errorMsgFunc(error.message)
    }
  }

  popupClose = () => {
    this.setState({
      waitingCmts: false,
      cancelAppointment: false
    })
  }
  addCancelComments = (comments) => {
    var states = this.state
    this.postPatientStatus('Cancelled', states.SelectedPatientDetails.appointment_id, comments, states.SelectedPatientDetails.timer, states.SelectedPatientDetails?.waiting_timer, states.SelectedPatientDetails)
    this.setState({
      cancelAppointment: false
    })
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  errorMsg() {
    this.setState({
      errormsg: this.props.error
    })
  }

  ReceiveClosePopUp() {
    this.setState({ OpPopupId: [] })
  }

  closeFilter = () => {
    this.setState({ FilterOpen: false })
  }

  ClearFilterData = () => {
    this.setState({
      Rescheduled: false,
      Cancelled: false,
      Transferred: false,
      SelectedPatientTags: []
    }, () => {
      this.getPatientDetails()
      this.setState({
        FilterOpen: false
      })
    })

  }

  renderFilterScreen = () => {
    const { t } = this.props
    return (
      <Box component={"div"} className='eMed_rts_filter_container'>
        <Box component={"div"} className='eMed_filter_Top'>
          <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
          <Button onClick={() => { this.setState({ FilterOpen: false }) }} className='eMed_usrconf_btn' emed_tid='opHome_filter_close_btn'>
            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
          </Button>
        </Box>
        <Box className="eMed_Filter_Header">
          <Typography marginLeft={"1vw"}>{t("Patient Filter")}</Typography>
        </Box>
        <Box className='eMed_rts_middle' display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
          <Box>
            {this.state.isQmsEnabled ? <Box display={'flex'}>
              <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.Rescheduled} onChange={(e) => { this.setState({ Rescheduled: e.target.checked }) }} size='small' emed_tid='opHome_filter_rescheduled_checkBox' />} label={t("Rescheduled")} />
              <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.Cancelled} onChange={(e) => { this.setState({ Cancelled: e.target.checked }) }} size='small' emed_tid='opHome_filter_cancelled_checkBox' />} label={t("Cancelled")} />
              <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox sx={{ fontSize: '0.4vw' }} checked={this.state.Transferred} onChange={(e) => { this.setState({ Transferred: e.target.checked }) }} size='small' emed_tid='opHome_filter_transferred_checkBox' />} label={t("Transferred")} />
            </Box> : null}
            {/* {localGetItem('show_patient_tag_filter') === 'true' ?
              <Box className='eMed_rts_dropdown'>
                <Autocomplete
                  multiple
                  limitTags={1}
                  size='small'
                  options={this.state.PatientTagList}
                  getOptionLabel={(option) => (option?.patient_tag_name)}
                  value={this.state.SelectedPatientTags}
                  onChange={(event, newValue) => {
                    this.setState({ SelectedPatientTags: newValue })
                  }}
                  renderOption={(props, option) => (
                    <li {...props} key={option?.patient_tag_name}>
                      {option?.patient_tag_name}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t('Select Patient Tag')}
                      emed_tid={"doctorName_TestID"}
                      sx={{ width: "20vw" }}
                    />
                  )}
                />
              </Box> : null} */}
          </Box>



          <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
            <Button variant='outlined' size="small" emed_tid='opHome_filter_clear_btn'
              onClick={() => { this.ClearFilterData() }}
              id="eMed_Config_btn">{t("Clear")}</Button>
            <Button variant='contained' size="small" emed_tid='opHome_filter_search_btn' disabled={this.state.disableBtn}
              onClick={() => {
                this.getPatientDetails()
                this.setState({
                  FilterOpen: false,
                  tagData: [],
                  tabClick: false,
                  SelectedPatientTags: []

                })
              }}
              id="eMed_Config_btn">{t("Search")}</Button>
          </Stack>
        </Box>
      </Box>
    )
  }

  getSpecializationData = () => {
    try {
      RestAPIService.getAll(Serviceurls.FO_CONFIG_OPSPECIALIZATION)
        .then((response) => {
          if (response.data.status === 'success') {
            this.setState({
              specializationList: response.data.data.filter((item) => (item.is_active === true))
            })
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.errorMsgFunc(error.message)
          }
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  getTransListData = () => {
    try {
      let startDate = new Date(this.state.datePickerTrans)
      let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      RestAPIService.getAll(Serviceurls.DOC_TRANSFER_REQUEST + '?appointment_date=' + date)
        .then((response) => {
          if (response.data.status === 'success') {
            let dataList = response.data.data
            dataList?.forEach(element => {
              let gender = element?.gender === 'm' ? 'M' : element.gender === 'f' ? 'F' : 'T'
              element.patientDetails = `${element?.title} ${element?.first_name} ${element?.last_name} (${element.patient_age}/${gender})`
              element.patientUnidMob = `${element?.patient_account_number} | ${element?.patient_mobile}`
              element.doctorName = `${element.from_doctor__title} ${element?.from_doctor__first_name} ${element?.from_doctor__qualifications}`
              element.doctor_data = null
              element.specialization_data = null
            })
            if (!this.state.tabClick) {
            this.setState({ transDataList: dataList })
            }  
          }
        }).catch(error => {
          if (error?.response?.data?.message) {
            this.errorMsgFunc(error.response.data.message)
          } else {
            this.errorMsgFunc(error.message)
          }
        })
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  postTransferListData = (item, status) => {
    try {
      var data = {
        "id": item?.row?.id,
        "status": status,
      }
      if (status === 'Approved') {
        data['doctor_id'] = item?.row?.doctor_data?.doctor_id ? item?.row?.doctor_data?.doctor_id : item?.row?.doctor_id
      }
      if (data?.doctor_id === null && status === 'Approved') {
        this.errorMsgFunc('Select Doctor Name')
      } else {
        RestAPIService.updateWithOutId(data, Serviceurls.DOC_TRANSFER_REQUEST)
          .then((response) => {
            if (response.data.status === 'success') {
              this.successMsgFunc(response.data.message)
              this.getPatientDetails()
              this.getTransListData()
              // this.setState({ openTransferList: false })
            }
          }).catch(error => {
            if (error?.response?.data?.message) {
              this.errorMsgFunc(error.response.data.message)
            } else {
              this.errorMsgFunc(error.message)
            }
          })
      }
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  renderTransferListPopup = () => {
    try {
      this.state.transDataList?.forEach((element, index) => element.sno = index + 1)
      const column = [
        {
          field: 'patientDetails', headerName: 'Patient Details', flex: 0.143,
          renderCell: (params) => {
            let patientName = params?.row?.patientDetails
            let patientAccMob = params?.row?.patientUnidMob
            return (
              <Box component={'div'}>
                {patientName ? patientName?.length > 20 ?
                  <Tooltip placement='top' title={patientName}><Box fontWeight={600} fontSize={'0.9vw'}>{patientName?.slice(0, 20) + '...'}</Box></Tooltip> :
                  <Box fontWeight={600} fontSize='0.9dvw'>{patientName}</Box> : '-'}
                {patientAccMob ? patientAccMob?.length > 20 ?
                  <Tooltip placement='top' title={patientAccMob}><Box fontSize={'0.8dvw'} color={Colors.grayShade}>{patientAccMob?.slice(0, 20) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.8dvw'} color={Colors.grayShade}>{patientAccMob}</Box> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'from_doctor__first_name', headerName: 'Previous Consultant', flex: 0.143,
          renderCell: (params) => {
            let doctorName = params?.row?.doctorName
            let specialisation = params?.row?.specialization_name
            return (
              <Box>
                {doctorName ? doctorName?.length > 12 ?
                  <Tooltip placement='top' title={doctorName}><Box fontSize={'0.9dvw'} fontWeight={600}>{doctorName?.slice(0, 12) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.9dvw'} fontWeight={600}>{doctorName}</Box> : '-'}
                {specialisation ? specialisation?.length > 12 ?
                  <Tooltip placement='top' title={specialisation}><Box fontSize={'0.8dvw'} color={Colors.grayShade}>{specialisation?.slice(0, 12) + '...'}</Box></Tooltip> :
                  <Box fontSize={'0.8dvw'} color={Colors.grayShade}>{specialisation}</Box> : '-'}
              </Box>
            )
          }
        },
        {
          field: 'purpose_of_visit', headerName: 'Purpose of Visit', flex: 0.143,
          renderCell: (params) => {
            let pov = params?.row?.purpose_of_visit
            return (
              pov ? pov?.length > 15 ?
                <Tooltip placement='top' title={pov}><Box>{pov?.slice(0, 15) + '...'}</Box></Tooltip> :
                pov : '-'
            )
          }
        },
        {
          field: 'transfer_notes', headerName: 'Transfer Notes', flex: 0.11,
          renderCell: (params) => {
            let notes = params?.row?.transfer_notes
            return (
              <Box>
                {notes ? notes?.length > 15 ?
                  <Tooltip placement='top' title={notes}><Box>{notes?.slice(0, 15) + '...'}</Box></Tooltip> :
                  notes : '-'}
              </Box>
            )
          }
        },
        {
          field: 'specilaization', headerName: 'Specializiation', flex: 0.183,
          renderCell: (params) => {
            let specialization = params?.row?.specialization_name
            return (
              <Box component={'div'}>
                {specialization ? specialization?.length > 20 ?
                  <Tooltip placement='top' title={specialization}><Box>{specialization?.slice(0, 20) + '...'}</Box></Tooltip> :
                  specialization : '-'}
              </Box>
            )
          }
        },
        {
          field: 'Doctor Name', headerName: 'Doctor Name', flex: 0.183,
          renderCell: (params) => {
            let docName = params?.row?.doctor_name
            return (
              <Box component={'div'}>
                {docName ?
                  docName ? docName?.length > 20 ?
                    <Tooltip placement='top' title={docName}><Box>{docName?.slice(0, 20) + '...'}</Box></Tooltip> :
                    docName : '-' :
                  <Autocomplete
                    clearIcon
                    size='small'
                    sx={{ width: '12dvw' }}
                    options={this.state.DoctorsList?.filter(item => item?.specialization_name === params?.row?.specialization_name)}
                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
                    value={params?.row?.doctor_name || params?.row?.doctor_data}
                    onChange={(e, newValue) => {
                      let transData = [...this.state.transDataList]
                      transData[params?.row?.sno - 1] = { ...transData[params?.row?.sno - 1], doctor_data: newValue }
                      this.setState({ transDataList: transData })
                    }}

                    renderInput={(params) => <TextField {...params} placeholder='Select Doctor Name' />}
                  />}
              </Box>
            )
          }
        },
        {
          field: 'action', headerName: 'Action', flex: 0.1,
          renderCell: (params) => {
            return (
              <Box component={'div'}>
                <Tooltip placement='top' title='Create Appointment'><Button
                  className='Common_Btn_Min_Width'
                  startIcon={<CheckCircleOutlineIcon color='primary' />}
                  onClick={() => this.postTransferListData(params, 'Approved')}
                /></Tooltip>
                <Tooltip placement='top' title={'Cancel'}>
                  <Button
                    className='Common_Btn_Min_Width'
                    startIcon={<CancelIcon color='error' />}
                    onClick={() => this.postTransferListData(params, 'Cancelled')}
                  ></Button>
                </Tooltip>
              </Box>
            )
          }
        },
      ]
      return (
        <Box component={'div'}>
          <Dialog
            open={this.state.openTransferList}
            maxWidth="lg"
            fullWidth
          >
            <Box className='emedhub_popup_lobby' p={'1rem'}>
              <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Box component={'div'} display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                  <Typography fontSize={'0.9dvw'} fontWeight={600} mr={'1rem'}>Transferred List</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      open={this.state.transDatePickerOpen}
                      onOpen={() => { this.setState({ transDatePickerOpen: true }) }}
                      onClose={() => { this.setState({ transDatePickerOpen: false }) }}
                      value={this.state.datePickerTrans}
                      name={"datePicker"}
                      inputFormat='DD-MM-YYYY'
                      views={["year", "month", "day"]}
                      onChange={(newDate) => {
                        this.setState({ datePickerTrans: newDate }, () => this.getTransListData());
                      }}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(e) => e.preventDefault()}
                          style={{ width: '10vw' }}
                          size='small'
                          {...params}
                          onClick={() => { this.setState({ transDatePickerOpen: true }) }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Box>
                <Button
                  className='Common_Btn_Min_Width'
                  onClick={() => this.setState({ openTransferList: false })}
                >
                  <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                </Button>
              </Box>
              <Box component={'div'} height={'30dvw'}>
                <DataGrid
                  columns={column}
                  rows={this.state.transDataList}
                  getRowId={(row) => row['sno']}
                  page={this.state.transPage}
                  pageSize={this.state.transPageSize}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    NoRowsOverlay: () => (
                      <Box className='' sx={{ position: 'relative', top: '10vw', left: '33vw' }}>
                        {'No Records To Be Shown'}
                      </Box>
                    )
                  }}
                  onPageChange={(newPage) => { this.setState({ transPage: newPage }) }}
                  onPageSizeChange={(newPageSize) => this.setState({ transPageSize: newPageSize })}
                  rowsPerPageOptions={[10, 20, 30]}
                  pagination
                  headerHeight={40}
                  disableSelectionOnClick
                  loading={this.state.loading}
                />
              </Box>
            </Box>
          </Dialog>
        </Box>
      )
    } catch (error) {
      this.errorMsgFunc(error.message)
    }
  }

  balanceViewPopup = () => {
    return (
      <Box component={'div'}>
        <Modal
          open={this.state.balanceVisible}
        >
          <Box component={'div'} className="eMed_BalancePop_style">
            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'0.5vw'} borderBottom={'1px solid lightgray'}>
              <Typography fontSize={'0.9vw'} fontWeight={600}>Balance Status</Typography>
              <Button
                className="Common_Btn_Min_Width"
                onClick={() => this.setState({ balanceVisible: false, balance_details: {}, balanceAmount: null })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box component={'div'} display={'flex'} justifyContent={'center'} p={'0.5vw'}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9vw', fontWeight: 600, color: Colors.SecondaryText }}>
                      Department
                    </TableCell>
                    <TableCell sx={{ backgroundColor: Colors.Background, fontSize: '0.9vw', fontWeight: 600, color: Colors.SecondaryText }}>
                      Balance
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.balance_details && Object.entries(this.state.balance_details).length > 0 ? (
                    Object.entries(this.state.balance_details).map(([dept, balance], index) => (
                      <TableRow key={index}>
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          {dept.length > 20 ? (
                            <Tooltip placement="top" title={dept}>
                              <div>{dept.slice(0, 20) + '...'}</div>
                            </Tooltip>
                          ) : (dept)}
                        </TableCell>
                        <TableCell>{balance}</TableCell>
                      </TableRow>
                    ))
                  ) : <TableRow>
                    <TableCell />
                    <TableCell>No Records</TableCell>
                  </TableRow>}
                </TableBody>
              </Table>
            </Box>
            <Box component={'div'} display={'flex'} p={'0.5vw'}>
              <span style={{ width: "14dvw", paddingLeft: "1dvw" }}>Total Balance Amount  </span>
              <span style={{ width: "13dvw", paddingLeft: "1dvw" }}>{this.state?.balanceAmount.toFixed(2)}</span>
            </Box>
          </Box>
        </Modal>
      </Box>
    )
  }

  render() {
    return (
      <div className='eMed_OP_Appointment'>
        {this.renderOPHeader()}
        {this.renderPatientType()}
        {this.renderAptTable()}
        {this.state.selectedOption != "" ? this.renderNxtApointmtPopup() : null}

        {this.state.selectedOption === "TransAppoint" ?
          <NextAppointments
            PostSuccess={this.NxtAppointmentSuccess.bind(this)}
            NxtAppiontmentClose={this.NxtAppiontmentClose.bind(this)}
            getPatientDetails={this.getPatientDetails.bind(this)}
            ScreenName={"TransAppoint"}
            PatientDetails={this.state.SelectedPatientDetails}
            AppointmentDate={this.state.datePicker}
            disableDatePicker={true}
            AppointmentType={true} /> : null

        }

        {this.state.cancelAppointment ? <ReasonPopup
          title={"Are you sure? Do you want to cancel the appointment"}
          AlertPopupClose={this.popupClose.bind(this)}
          label={"Enter the Reason"}
          btntext={'Cancel'}
          btnvarient={'outlined'}
          btncolor={'error'}
          btntext1={'Confirm'}
          btnvarient1={'contained'}
          sendCmt={this.addCancelComments.bind(this)} /> : null}
        {this.state.creditBillPopUp ?
          <CreditBillCompletePoP
            Module_ID_Key_Name={"appointment_id"}
            Module_ID_Key_Value={this.state.opCreditBill?.appointment_id}
            modules={['op', 'lab', 'pharmacy', 'ot', 'radiology']}
            CrebillPosted={this.creditBillPost}
            BillData={this.state.PatientDetails}
            ClosePopUp={this.ClosePopUp.bind(this)}
            CollectedIn={"OP"}
            FromFrontOffice={true}
          /> : null}
        {this.state.OpPopupId?.length > 0 ?
          <BillSuccessPoPUp isFromOPHome={true} BilllistArray={this.state.OpPopupId} CloseBtnText={'close'} ClosePopUp={this.ReceiveClosePopUp.bind(this)} error={this.errorMsgFunc.bind(this)} /> : null}

        <Drawer
          anchor={'right'}
          open={this.state.FilterOpen}
          ModalProps={{ onBackdropClick: this.closeFilter }}
        >
          {this.renderFilterScreen()}
        </Drawer>
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.receiptID !== null ?
          <BillSuccessPoPUp creditreceipt={this.state.receiptID} phrma_creditreceipt={this.state.pharmacReceipt} ClosePopUp={this.ClosesuccessPopUp.bind(this)} />
          : null}

        {this.state.ispovPopOpen ?
          <PovEditPopup
            povEditText={this.state.povText.purpose_of_visit}
            povData={this.state.povText}
            getTableData={this.getPatientDetails.bind(this)}
            AlertPopupClose={this.povPopClose.bind(this)}
            successMsg={this.successMsgFunc.bind(this)}
            errorMsg={this.errorMsgFunc.bind(this)}
          /> : null}
        {this.state.balanceVisible ?
          this.balanceViewPopup()
          : null
        }
        {this.state.moveIpPopup ?
          <ConfirmPopup
            cnfTitle={'Confirmation'}
            cnfContent1={'Do you want to move this appointment to Inpatient ?'}
            cnfAlertPopupClose={this.closemoveIp.bind(this)}
            cnfData={this.confirmSaveOpToIp.bind(this)}
          />
          : null
        }
        {this.renderTransferListPopup()}
      </div>

    )
  }
}

export default withTranslation()(OutpatientHome);